var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formular!=undefined)?_c('div',[_c('div',{staticStyle:{"font-family":"Arial, Verdana, sans-serif","border":"solid 1px black","position":"relative","width":"909px","height":"1286px","overflow":"hidden","background-color":"white","margin":"0 auto 10px"}},[_c('div',{style:({
														fontSize:'18px',
														fontWeight:'bold',
														position:'absolute', 
														left: _vm.spalte_breit_mm(6.6790799) + 'px', 
														top: _vm.gib_hoehe_in_mm(19.6119546) + 'px'})},[_vm._v(" Statistik der Baugenehmigungen ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														position:'absolute', 
														left: _vm.spalte_breit_mm(6.6790799) + 'px', 
														top: _vm.gib_hoehe_in_mm(27.2489677) + 'px'})},[_vm._v(" Bitte lesen Sie vor dem Ausfüllen die dazugehörigen Erläuterungen. ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														position:'absolute', 
														left: _vm.spalte_breit_mm(90.6082773) + 'px', 
														top: _vm.gib_hoehe_in_mm(21.3497075) + 'px'})},[_vm._v(" BG Füllen Sie den Fragebogen aus bei ... ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.7620328) + 'px', 
														top: _vm.gib_hoehe_in_mm(25.767275) + 'px'})},[_vm._v(" ... Neubau (für jedes Gebäude ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8375768) + 'px', 
														top: _vm.gib_hoehe_in_mm(28.5962817) + 'px'})},[_vm._v(" 1 Erhebungsbogen ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.862905) + 'px', 
														top: _vm.gib_hoehe_in_mm(33.9082964) + 'px'})},[_vm._v(" ... Baumaßnahmen an einem ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.139488) + 'px', 
														top: _vm.gib_hoehe_in_mm(36.7373031) + 'px'})},[_vm._v(" bestehenden Gebäude. ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.862905) + 'px', 
														top: _vm.gib_hoehe_in_mm(41.7682159) + 'px'})},[_vm._v(" ... Änderung des Nutzungsschwer ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8626185) + 'px', 
														top: _vm.gib_hoehe_in_mm(44.7308959) + 'px'})},[_vm._v(" punkts zwischen Wohnbau und ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8626185) + 'px', 
														top: _vm.gib_hoehe_in_mm(48.00501) + 'px'})},[_vm._v(" Nichtwohnbau (bitte zusätzlich ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8626185) + 'px', 
														top: _vm.gib_hoehe_in_mm(50.833664) + 'px'})},[_vm._v(" einen Abgangsbogen ausfüllen). ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(22.1683242) + 'px'})},[_vm._v(" Information und Technik ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(25.1655688) + 'px'})},[_vm._v(" NordrheinWestfalen ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(28.1628134) + 'px'})},[_vm._v(" Geschäftsbereich Statistik ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(31.160058) + 'px'})},[_vm._v(" Referat 535 Paderborn ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(34.1569499) + 'px'})},[_vm._v(" 40193 Düsseldorf ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(39.8008553) + 'px'})},[_vm._v(" Sie erreichen uns über ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(43.6272976) + 'px'})},[_vm._v(" Telefon 0211 9449 4664 ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(47.1701691) + 'px'})},[_vm._v(" Telefax 0211 9449 4658 ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.5903352) + 'px', 
														top: _vm.gib_hoehe_in_mm(50.6252183) + 'px'})},[_vm._v(" EMail bautaetigkeitit.nrw.de ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5630145) + 'px', 
														top: _vm.gib_hoehe_in_mm(66.8201442) + 'px'})},[_vm._v(" Kenntnisgabe, Anzeige bzw. Genehmigungs ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5630145) + 'px', 
														top: _vm.gib_hoehe_in_mm(70.2057115) + 'px'})},[_vm._v(" freistellung entspricht jeweiligem Landesrecht ............ ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(188.2437494) + 'px', 
														top: _vm.gib_hoehe_in_mm(65.2206497) + 'px'})},[_vm._v(" Ja ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(196.4919916) + 'px', 
														top: _vm.gib_hoehe_in_mm(65.2206497) + 'px'})},[_vm._v(" Nein ")]),(_vm.formular.landesrecht_ja!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(187.8769414) + 'px',top: _vm.gib_hoehe_in_mm(69.7857222) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.landesrecht_ja.text),callback:function ($$v) {_vm.$set(_vm.formular.landesrecht_ja, "text", $$v)},expression:"formular.landesrecht_ja.text"}}):_vm._e(),(_vm.formular.landesrecht_nein!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(198.5404732) + 'px',top: _vm.gib_hoehe_in_mm(69.7857222) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.landesrecht_nein.text),callback:function ($$v) {_vm.$set(_vm.formular.landesrecht_nein, "text", $$v)},expression:"formular.landesrecht_nein.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'13.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(51.9089752) + 'px', 
														top: _vm.gib_hoehe_in_mm(53.3367759) + 'px'})},[_vm._v(" (Blockschrift) ")]),(_vm.formular.identnummer)?_c('b-popover',{ref:"identnummer",attrs:{"show":_vm.formular.identnummer.showPop==true,"target":"identnummer"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.identnummer.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.identnummer.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("identnummer", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("identnummer", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.identnummer!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.identnummer.text),expression:"formular.identnummer.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(39.2768006) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(7.4246234) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(35.7575146) + 'px', 
		
														'font-size': _vm.formular.identnummer.size + 'px', 
														'text-align': _vm.formular.identnummer.schriftausrichtung, 
														'letter-spacing': _vm.formular.identnummer.letterSpacing + 'px',
														'font-weight': _vm.formular.identnummer.schriftart }),attrs:{"id":"identnummer","type":"text","disabled":_vm.formular.identnummer.isDisabled==true || _vm.formular.identnummer.isDisabled==true},domProps:{"value":(_vm.formular.identnummer.text)},on:{"focus":function($event){_vm.formular.identnummer.showPop=true},"blur":function($event){_vm.formular.identnummer.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.identnummer, "text", $event.target.value)},_vm.nummerAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.identnummer.onylNumber)}}}):_vm._e(),(_vm.formular.bauscheinnummer)?_c('b-popover',{ref:"bauscheinnummer",attrs:{"show":_vm.formular.bauscheinnummer.showPop==true,"target":"bauscheinnummer"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauscheinnummer.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauscheinnummer.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauscheinnummer", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauscheinnummer", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauscheinnummer!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauscheinnummer.text),expression:"formular.bauscheinnummer.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(85.7312703) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(6.9276691) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(43.7437007) + 'px', 
		
														'font-size': _vm.formular.bauscheinnummer.size + 'px', 
														'text-align': _vm.formular.bauscheinnummer.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauscheinnummer.letterSpacing + 'px',
														'font-weight': _vm.formular.bauscheinnummer.schriftart }),attrs:{"id":"bauscheinnummer","type":"text","disabled":_vm.formular.bauscheinnummer.isDisabled==true || _vm.formular.bauscheinnummer.isDisabled==true},domProps:{"value":(_vm.formular.bauscheinnummer.text)},on:{"focus":function($event){_vm.formular.bauscheinnummer.showPop=true},"blur":function($event){_vm.formular.bauscheinnummer.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauscheinnummer.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauscheinnummer, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.6790799) + 'px', 
														top: _vm.gib_hoehe_in_mm(39.5656044) + 'px'})},[_vm._v(" Identifikationsnummer ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.6247641) + 'px', 
														top: _vm.gib_hoehe_in_mm(47.6046955) + 'px'})},[_vm._v(" Bauscheinnummer/Aktenzeichen ")]),_c('div',{style:({
														fontSize:'15px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.6790799) + 'px', 
														top: _vm.gib_hoehe_in_mm(53.0584956) + 'px'})},[_vm._v(" 1 Allgemeine Angaben ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6783452) + 'px', 
														top: _vm.gib_hoehe_in_mm(58.1825212) + 'px'})},[_vm._v(" Bauherr/Bauherrin ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6783452) + 'px', 
														top: _vm.gib_hoehe_in_mm(62.2371604) + 'px'})},[_vm._v(" Name/Firma ")]),(_vm.formular.bauherr_name1)?_c('b-popover',{ref:"bauherr_name1",attrs:{"show":_vm.formular.bauherr_name1.showPop==true,"target":"bauherr_name1"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_name1.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_name1.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name1", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name1", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_name1!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_name1.text),expression:"formular.bauherr_name1.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1344574) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(33.0257056) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(65.8368287) + 'px', 
		
														'font-size': _vm.formular.bauherr_name1.size + 'px', 
														'text-align': _vm.formular.bauherr_name1.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_name1.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_name1.schriftart }),attrs:{"id":"bauherr_name1","type":"text","disabled":_vm.formular.bauherr_name1.isDisabled==true || _vm.formular.bauherr_name1.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_name1.text)},on:{"focus":function($event){_vm.formular.bauherr_name1.showPop=true},"blur":function($event){_vm.formular.bauherr_name1.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_name1, "text", $event.target.value)},_vm.bauherrAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_name1.onylNumber)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(77.6783664) + 'px'})},[_vm._v(" Anschrift ")]),(_vm.formular.bauherr_name2)?_c('b-popover',{ref:"bauherr_name2",attrs:{"show":_vm.formular.bauherr_name2.showPop==true,"target":"bauherr_name2"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_name2.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_name2.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name2", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name2", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_name2!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_name2.text),expression:"formular.bauherr_name2.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1344574) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(33.0257056) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(72.3356789) + 'px', 
		
														'font-size': _vm.formular.bauherr_name2.size + 'px', 
														'text-align': _vm.formular.bauherr_name2.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_name2.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_name2.schriftart }),attrs:{"id":"bauherr_name2","type":"text","disabled":_vm.formular.bauherr_name2.isDisabled==true || _vm.formular.bauherr_name2.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_name2.text)},on:{"focus":function($event){_vm.formular.bauherr_name2.showPop=true},"blur":function($event){_vm.formular.bauherr_name2.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_name2, "text", $event.target.value)},_vm.bauherrAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_name2.onylNumber)}}}):_vm._e(),(_vm.formular.bauherr_anschrift1)?_c('b-popover',{ref:"bauherr_anschrift1",attrs:{"show":_vm.formular.bauherr_anschrift1.showPop==true,"target":"bauherr_anschrift1"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_anschrift1.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_anschrift1.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift1", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift1", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_anschrift1!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_anschrift1.text),expression:"formular.bauherr_anschrift1.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1344574) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(33.0257056) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(78.8341764) + 'px', 
		
														'font-size': _vm.formular.bauherr_anschrift1.size + 'px', 
														'text-align': _vm.formular.bauherr_anschrift1.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_anschrift1.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_anschrift1.schriftart }),attrs:{"id":"bauherr_anschrift1","type":"text","disabled":_vm.formular.bauherr_anschrift1.isDisabled==true || _vm.formular.bauherr_anschrift1.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_anschrift1.text)},on:{"focus":function($event){_vm.formular.bauherr_anschrift1.showPop=true},"blur":function($event){_vm.formular.bauherr_anschrift1.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_anschrift1, "text", $event.target.value)},_vm.bauherrAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_anschrift1.onylNumber)}}}):_vm._e(),(_vm.formular.bauherr_anschrift2)?_c('b-popover',{ref:"bauherr_anschrift2",attrs:{"show":_vm.formular.bauherr_anschrift2.showPop==true,"target":"bauherr_anschrift2"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_anschrift2.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_anschrift2.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift2", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift2", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_anschrift2!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_anschrift2.text),expression:"formular.bauherr_anschrift2.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1344574) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(33.0257056) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(85.827512) + 'px', 
		
														'font-size': _vm.formular.bauherr_anschrift2.size + 'px', 
														'text-align': _vm.formular.bauherr_anschrift2.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_anschrift2.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_anschrift2.schriftart }),attrs:{"id":"bauherr_anschrift2","type":"text","disabled":_vm.formular.bauherr_anschrift2.isDisabled==true || _vm.formular.bauherr_anschrift2.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_anschrift2.text)},on:{"focus":function($event){_vm.formular.bauherr_anschrift2.showPop=true},"blur":function($event){_vm.formular.bauherr_anschrift2.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_anschrift2, "text", $event.target.value)},_vm.bauherrAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_anschrift2.onylNumber)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(92.7291335) + 'px'})},[_vm._v(" Anschrift des Baugrundstücks ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(96.7837727) + 'px'})},[_vm._v(" Straße, ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(100.3107727) + 'px'})},[_vm._v(" Nummer ")]),(_vm.formular.baugrundstueck_strasse)?_c('b-popover',{ref:"baugrundstueck_strasse",attrs:{"show":_vm.formular.baugrundstueck_strasse.showPop==true,"target":"baugrundstueck_strasse"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_strasse.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_strasse.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_strasse", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_strasse", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_strasse!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_strasse.text),expression:"formular.baugrundstueck_strasse.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.2625754) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.8159446) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(99.4667737) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_strasse.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_strasse.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_strasse.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_strasse.schriftart }),attrs:{"id":"baugrundstueck_strasse","type":"text","disabled":_vm.formular.baugrundstueck_strasse.isDisabled==true || _vm.formular.baugrundstueck_strasse.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_strasse.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_strasse.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_strasse.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_strasse, "text", $event.target.value)},_vm.grundstueckAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_strasse.onylNumber)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(104.8641297) + 'px'})},[_vm._v(" Postleitzahl, ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(108.3911297) + 'px'})},[_vm._v(" Ort ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(116.4439761) + 'px'})},[_vm._v(" Lage des Baugrundstücks ")]),(_vm.formular.baugrundstueck_plz)?_c('b-popover',{ref:"baugrundstueck_plz",attrs:{"show":_vm.formular.baugrundstueck_plz.showPop==true,"target":"baugrundstueck_plz"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_plz.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_plz.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_plz", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_plz", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_plz!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_plz.text),expression:"formular.baugrundstueck_plz.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(10.4421648) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.8159446) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(107.546778) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_plz.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_plz.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_plz.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_plz.schriftart }),attrs:{"id":"baugrundstueck_plz","type":"text","disabled":_vm.formular.baugrundstueck_plz.isDisabled==true || _vm.formular.baugrundstueck_plz.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_plz.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_plz.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_plz.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_plz, "text", $event.target.value)},_vm.grundstueckAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_plz.onylNumber)}}}):_vm._e(),(_vm.formular.baugrundstueck_ort)?_c('b-popover',{ref:"baugrundstueck_ort",attrs:{"show":_vm.formular.baugrundstueck_ort.showPop==true,"target":"baugrundstueck_ort"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_ort.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_ort.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_ort", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_ort", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_ort!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_ort.text),expression:"formular.baugrundstueck_ort.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.3073683) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(45.7373663) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(107.546778) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_ort.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_ort.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_ort.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_ort.schriftart }),attrs:{"id":"baugrundstueck_ort","type":"text","disabled":_vm.formular.baugrundstueck_ort.isDisabled==true || _vm.formular.baugrundstueck_ort.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_ort.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_ort.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_ort.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_ort, "text", $event.target.value)},_vm.grundstueckAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_ort.onylNumber)}}}):_vm._e(),(_vm.formular.ansprechpartnerTelefon)?_c('b-popover',{ref:"ansprechpartnerTelefon",attrs:{"show":_vm.formular.ansprechpartnerTelefon.showPop==true,"target":"ansprechpartnerTelefon"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.ansprechpartnerTelefon.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.ansprechpartnerTelefon.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerTelefon", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerTelefon", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.ansprechpartnerTelefon!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.ansprechpartnerTelefon.text),expression:"formular.ansprechpartnerTelefon.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(87.7497724) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(107.7325034) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(107.4028764) + 'px', 
		
														'font-size': _vm.formular.ansprechpartnerTelefon.size + 'px', 
														'text-align': _vm.formular.ansprechpartnerTelefon.schriftausrichtung, 
														'letter-spacing': _vm.formular.ansprechpartnerTelefon.letterSpacing + 'px',
														'font-weight': _vm.formular.ansprechpartnerTelefon.schriftart }),attrs:{"id":"ansprechpartnerTelefon","type":"text","disabled":_vm.formular.ansprechpartnerTelefon.isDisabled==true || _vm.formular.ansprechpartnerTelefon.isDisabled==true},domProps:{"value":(_vm.formular.ansprechpartnerTelefon.text)},on:{"focus":function($event){_vm.formular.ansprechpartnerTelefon.showPop=true},"blur":function($event){_vm.formular.ansprechpartnerTelefon.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.ansprechpartnerTelefon.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.ansprechpartnerTelefon, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5619564) + 'px', 
														top: _vm.gib_hoehe_in_mm(90.7762336) + 'px'})},[_vm._v(" Ansprechpartner/in für Rückfragen ")]),(_vm.formular.baugrundstueck_nummer)?_c('b-popover',{ref:"baugrundstueck_nummer",attrs:{"show":_vm.formular.baugrundstueck_nummer.showPop==true,"target":"baugrundstueck_nummer"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_nummer.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_nummer.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_nummer", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_nummer", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_nummer!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_nummer.text),expression:"formular.baugrundstueck_nummer.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(10.4421648) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(90.6025698) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(99.4667737) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_nummer.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_nummer.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_nummer.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_nummer.schriftart }),attrs:{"id":"baugrundstueck_nummer","type":"text","disabled":_vm.formular.baugrundstueck_nummer.isDisabled==true || _vm.formular.baugrundstueck_nummer.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_nummer.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_nummer.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_nummer.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_nummer, "text", $event.target.value)},_vm.grundstueckAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_nummer.onylNumber)}}}):_vm._e(),(_vm.formular.ansprechpartnerName)?_c('b-popover',{ref:"ansprechpartnerName",attrs:{"show":_vm.formular.ansprechpartnerName.showPop==true,"target":"ansprechpartnerName"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.ansprechpartnerName.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.ansprechpartnerName.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerName", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerName", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.ansprechpartnerName!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.ansprechpartnerName.text),expression:"formular.ansprechpartnerName.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(87.7497724) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(107.7325034) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(97.1643481) + 'px', 
		
														'font-size': _vm.formular.ansprechpartnerName.size + 'px', 
														'text-align': _vm.formular.ansprechpartnerName.schriftausrichtung, 
														'letter-spacing': _vm.formular.ansprechpartnerName.letterSpacing + 'px',
														'font-weight': _vm.formular.ansprechpartnerName.schriftart }),attrs:{"id":"ansprechpartnerName","type":"text","disabled":_vm.formular.ansprechpartnerName.isDisabled==true || _vm.formular.ansprechpartnerName.isDisabled==true},domProps:{"value":(_vm.formular.ansprechpartnerName.text)},on:{"focus":function($event){_vm.formular.ansprechpartnerName.showPop=true},"blur":function($event){_vm.formular.ansprechpartnerName.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.ansprechpartnerName.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.ansprechpartnerName, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5630145) + 'px', 
														top: _vm.gib_hoehe_in_mm(101.1597216) + 'px'})},[_vm._v(" Name ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5630145) + 'px', 
														top: _vm.gib_hoehe_in_mm(111.3982499) + 'px'})},[_vm._v(" Telefon und/oder EMail ")]),(_vm.formular.baugrundstueck_lage)?_c('b-popover',{ref:"baugrundstueck_lage",attrs:{"show":_vm.formular.baugrundstueck_lage.showPop==true,"target":"baugrundstueck_lage"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_lage.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_lage.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_lage", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_lage", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_lage!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_lage.text),expression:"formular.baugrundstueck_lage.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.0040463) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.8159446) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(123.5043368) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_lage.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_lage.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_lage.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_lage.schriftart }),attrs:{"id":"baugrundstueck_lage","type":"text","disabled":_vm.formular.baugrundstueck_lage.isDisabled==true || _vm.formular.baugrundstueck_lage.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_lage.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_lage.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_lage.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_lage.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_lage, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.baugrundstueckNR)?_c('b-popover',{ref:"baugrundstueckNR",attrs:{"show":_vm.formular.baugrundstueckNR.showPop==true,"target":"baugrundstueckNR"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueckNR.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueckNR.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueckNR", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueckNR", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueckNR!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueckNR.text),expression:"formular.baugrundstueckNR.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.9974763) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(89.8171069) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(123.5043368) + 'px', 
		
														'font-size': _vm.formular.baugrundstueckNR.size + 'px', 
														'text-align': _vm.formular.baugrundstueckNR.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueckNR.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueckNR.schriftart }),attrs:{"id":"baugrundstueckNR","type":"text","disabled":_vm.formular.baugrundstueckNR.isDisabled==true || _vm.formular.baugrundstueckNR.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueckNR.text)},on:{"focus":function($event){_vm.formular.baugrundstueckNR.showPop=true},"blur":function($event){_vm.formular.baugrundstueckNR.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueckNR.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueckNR, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.baugrundstueck_gemeinde)?_c('b-popover',{ref:"baugrundstueck_gemeinde",attrs:{"show":_vm.formular.baugrundstueck_gemeinde.showPop==true,"target":"baugrundstueck_gemeinde"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_gemeinde.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_gemeinde.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeinde", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeinde", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_gemeinde!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_gemeinde.text),expression:"formular.baugrundstueck_gemeinde.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.0040463) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.8159446) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(131.5025147) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_gemeinde.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_gemeinde.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_gemeinde.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_gemeinde.schriftart }),attrs:{"id":"baugrundstueck_gemeinde","type":"text","disabled":_vm.formular.baugrundstueck_gemeinde.isDisabled==true || _vm.formular.baugrundstueck_gemeinde.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_gemeinde.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_gemeinde.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_gemeinde.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_gemeinde, "text", $event.target.value)},_vm.grundstueckLageAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_gemeinde.onylNumber)}}}):_vm._e(),(_vm.formular.baugrundstueckgemeindeNR)?_c('b-popover',{ref:"baugrundstueckgemeindeNR",attrs:{"show":_vm.formular.baugrundstueckgemeindeNR.showPop==true,"target":"baugrundstueckgemeindeNR"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueckgemeindeNR.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueckgemeindeNR.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueckgemeindeNR", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueckgemeindeNR", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueckgemeindeNR!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueckgemeindeNR.text),expression:"formular.baugrundstueckgemeindeNR.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.9974763) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(89.8171069) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(131.5025147) + 'px', 
		
														'font-size': _vm.formular.baugrundstueckgemeindeNR.size + 'px', 
														'text-align': _vm.formular.baugrundstueckgemeindeNR.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueckgemeindeNR.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueckgemeindeNR.schriftart }),attrs:{"id":"baugrundstueckgemeindeNR","type":"text","disabled":_vm.formular.baugrundstueckgemeindeNR.isDisabled==true || _vm.formular.baugrundstueckgemeindeNR.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueckgemeindeNR.text)},on:{"focus":function($event){_vm.formular.baugrundstueckgemeindeNR.showPop=true},"blur":function($event){_vm.formular.baugrundstueckgemeindeNR.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueckgemeindeNR.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueckgemeindeNR, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.baugrundstueck_gemeindeTeil)?_c('b-popover',{ref:"baugrundstueck_gemeindeTeil",attrs:{"show":_vm.formular.baugrundstueck_gemeindeTeil.showPop==true,"target":"baugrundstueck_gemeindeTeil"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_gemeindeTeil.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_gemeindeTeil.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeindeTeil", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeindeTeil", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_gemeindeTeil!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_gemeindeTeil.text),expression:"formular.baugrundstueck_gemeindeTeil.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.0040463) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.8159446) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(139.5010453) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_gemeindeTeil.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_gemeindeTeil.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_gemeindeTeil.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_gemeindeTeil.schriftart }),attrs:{"id":"baugrundstueck_gemeindeTeil","type":"text","disabled":_vm.formular.baugrundstueck_gemeindeTeil.isDisabled==true || _vm.formular.baugrundstueck_gemeindeTeil.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_gemeindeTeil.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_gemeindeTeil.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_gemeindeTeil.showPop=false},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_gemeindeTeil, "text", $event.target.value)},_vm.grundstueckLageAndereSeiten],"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_gemeindeTeil.onylNumber)}}}):_vm._e(),(_vm.formular.baugrundstueckgemeindeTeilNR)?_c('b-popover',{ref:"baugrundstueckgemeindeTeilNR",attrs:{"show":_vm.formular.baugrundstueckgemeindeTeilNR.showPop==true,"target":"baugrundstueckgemeindeTeilNR"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueckgemeindeTeilNR.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueckgemeindeTeilNR.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueckgemeindeTeilNR", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueckgemeindeTeilNR", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueckgemeindeTeilNR!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueckgemeindeTeilNR.text),expression:"formular.baugrundstueckgemeindeTeilNR.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.8281803) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(89.9864029) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(139.5010453) + 'px', 
		
														'font-size': _vm.formular.baugrundstueckgemeindeTeilNR.size + 'px', 
														'text-align': _vm.formular.baugrundstueckgemeindeTeilNR.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueckgemeindeTeilNR.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueckgemeindeTeilNR.schriftart }),attrs:{"id":"baugrundstueckgemeindeTeilNR","type":"text","disabled":_vm.formular.baugrundstueckgemeindeTeilNR.isDisabled==true || _vm.formular.baugrundstueckgemeindeTeilNR.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueckgemeindeTeilNR.text)},on:{"focus":function($event){_vm.formular.baugrundstueckgemeindeTeilNR.showPop=true},"blur":function($event){_vm.formular.baugrundstueckgemeindeTeilNR.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueckgemeindeTeilNR.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueckgemeindeTeilNR, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(132.4406846) + 'px'})},[_vm._v(" Gemeinde ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(140.4388625) + 'px'})},[_vm._v(" Gemeindeteil ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(148.4917089) + 'px'})},[_vm._v(" Datum der Baugenehmigung ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.6772871) + 'px', 
														top: _vm.gib_hoehe_in_mm(152.0187089) + 'px'})},[_vm._v(" bzw. Genehmigungsfreistellung ................... ")]),(_vm.formular.BG_Monat)?_c('b-popover',{ref:"BG_Monat",attrs:{"show":_vm.formular.BG_Monat.showPop==true,"target":"BG_Monat"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.BG_Monat.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.BG_Monat.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Monat", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Monat", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.BG_Monat!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.BG_Monat.text),expression:"formular.BG_Monat.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(8.4980824) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(74.9673788) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(151.080539) + 'px', 
		
														'font-size': _vm.formular.BG_Monat.size + 'px', 
														'text-align': _vm.formular.BG_Monat.schriftausrichtung, 
														'letter-spacing': _vm.formular.BG_Monat.letterSpacing + 'px',
														'font-weight': _vm.formular.BG_Monat.schriftart }),attrs:{"id":"BG_Monat","type":"text","disabled":_vm.formular.BG_Monat.isDisabled==true || _vm.formular.BG_Monat.isDisabled==true},domProps:{"value":(_vm.formular.BG_Monat.text)},on:{"focus":function($event){_vm.formular.BG_Monat.showPop=true},"blur":function($event){_vm.formular.BG_Monat.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.BG_Monat.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.BG_Monat, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.BG_Jahr)?_c('b-popover',{ref:"BG_Jahr",attrs:{"show":_vm.formular.BG_Jahr.showPop==true,"target":"BG_Jahr"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.BG_Jahr.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.BG_Jahr.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Jahr", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Jahr", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.BG_Jahr!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.BG_Jahr.text),expression:"formular.BG_Jahr.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(16.4962603) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(86.0710802) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(151.080539) + 'px', 
		
														'font-size': _vm.formular.BG_Jahr.size + 'px', 
														'text-align': _vm.formular.BG_Jahr.schriftausrichtung, 
														'letter-spacing': _vm.formular.BG_Jahr.letterSpacing + 'px',
														'font-weight': _vm.formular.BG_Jahr.schriftart }),attrs:{"id":"BG_Jahr","type":"text","disabled":_vm.formular.BG_Jahr.isDisabled==true || _vm.formular.BG_Jahr.isDisabled==true},domProps:{"value":(_vm.formular.BG_Jahr.text)},on:{"focus":function($event){_vm.formular.BG_Jahr.showPop=true},"blur":function($event){_vm.formular.BG_Jahr.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.BG_Jahr.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.BG_Jahr, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(75.7095239) + 'px', 
														top: _vm.gib_hoehe_in_mm(155.924156) + 'px'})},[_vm._v(" Monat ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(91.6215844) + 'px', 
														top: _vm.gib_hoehe_in_mm(155.924156) + 'px'})},[_vm._v(" Jahr ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.2003781) + 'px', 
														top: _vm.gib_hoehe_in_mm(165.4163711) + 'px'})},[_vm._v(" Art der Bautätigkeit2 ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(4.1029591) + 'px', 
														top: _vm.gib_hoehe_in_mm(173.6021854) + 'px'})},[_vm._v(" nur ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(4.1029591) + 'px', 
														top: _vm.gib_hoehe_in_mm(175.9585741) + 'px'})},[_vm._v(" Neubau ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.2003781) + 'px', 
														top: _vm.gib_hoehe_in_mm(171.0264173) + 'px'})},[_vm._v(" Errichtung eines neuen Gebäudes überwiegend ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(22.1985853) + 'px', 
														top: _vm.gib_hoehe_in_mm(176.5257157) + 'px'})},[_vm._v(" in konventioneller Bauart ................................................... ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(22.202465) + 'px', 
														top: _vm.gib_hoehe_in_mm(181.5241801) + 'px'})},[_vm._v(" im Fertigteilbau .................................................................... ")]),(_vm.formular.konventionelle_bauart!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(98.2124893) + 'px',top: _vm.gib_hoehe_in_mm(176.105021) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.konventionelle_bauart.text),callback:function ($$v) {_vm.$set(_vm.formular.konventionelle_bauart, "text", $$v)},expression:"formular.konventionelle_bauart.text"}}):_vm._e(),(_vm.formular.fertigbau!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(98.2124893) + 'px',top: _vm.gib_hoehe_in_mm(181.1038381) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.fertigbau.text),callback:function ($$v) {_vm.$set(_vm.formular.fertigbau, "text", $$v)},expression:"formular.fertigbau.text"}}):_vm._e(),(_vm.formular.bestehendesGebaude!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(98.2124893) + 'px',top: _vm.gib_hoehe_in_mm(186.6884899) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.bestehendesGebaude.text),callback:function ($$v) {_vm.$set(_vm.formular.bestehendesGebaude, "text", $$v)},expression:"formular.bestehendesGebaude.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.2003781) + 'px', 
														top: _vm.gib_hoehe_in_mm(187.1088319) + 'px'})},[_vm._v(" Baumaßnahme an bestehendem Gebäude ...................... ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.2003781) + 'px', 
														top: _vm.gib_hoehe_in_mm(192.1623175) + 'px'})},[_vm._v(" Bei Baumaßnahme an bestehendem Gebäude ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.2003781) + 'px', 
														top: _vm.gib_hoehe_in_mm(197.2158031) + 'px'})},[_vm._v(" Ändert sich der Nutzungsschwerpunkt des Ge ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.2003781) + 'px', 
														top: _vm.gib_hoehe_in_mm(200.7428031) + 'px'})},[_vm._v(" bäudes zwischen Wohnbau und Nichtwohnbau ? ..... ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(89.5815676) + 'px', 
														top: _vm.gib_hoehe_in_mm(195.7577413) + 'px'})},[_vm._v(" Ja Nein ")]),(_vm.formular.nutzungsschwerpunkt_ja!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(89.2144069) + 'px',top: _vm.gib_hoehe_in_mm(200.3224611) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.nutzungsschwerpunkt_ja.text),callback:function ($$v) {_vm.$set(_vm.formular.nutzungsschwerpunkt_ja, "text", $$v)},expression:"formular.nutzungsschwerpunkt_ja.text"}}):_vm._e(),(_vm.formular.nutzungsschwerpunkt_nein!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(98.1285467) + 'px',top: _vm.gib_hoehe_in_mm(200.3224611) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.nutzungsschwerpunkt_nein.text),callback:function ($$v) {_vm.$set(_vm.formular.nutzungsschwerpunkt_nein, "text", $$v)},expression:"formular.nutzungsschwerpunkt_nein.text"}}):_vm._e(),_c('span',{staticClass:"input_formular",style:({width: _vm.spalte_breit_mm(69.1367353) + 'px', 
										 position:'absolute', 
										 left: _vm.spalte_breit_mm(110.7887132) + 'px',
										
										 top: _vm.gib_hoehe_in_mm(199.1098785) + 'px'})},[(_vm.formular.nutzungsartNichtWohnbau)?_c('b-popover',{ref:"nutzungsartNichtWohnbau",attrs:{"show":_vm.formular.nutzungsartNichtWohnbau.showPop==true,"target":"nutzungsartNichtWohnbau"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.nutzungsartNichtWohnbau.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.nutzungsartNichtWohnbau.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("nutzungsartNichtWohnbau", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("nutzungsartNichtWohnbau", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.nutzungsartNichtWohnbau!=undefined)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.nutzungsartNichtWohnbau.text),expression:"formular.nutzungsartNichtWohnbau.text"}],staticClass:"textfeld",staticStyle:{"width":"100%","line-height":"1.2"},style:({'font-size': _vm.formular.nutzungsartNichtWohnbau.size + 'px',
														'height': _vm.formular.nutzungsartNichtWohnbau.height + 'px',
														'text-align': _vm.formular.nutzungsartNichtWohnbau.schriftausrichtung + 'px',
														'letter-spacing': _vm.formular.nutzungsartNichtWohnbau.letterSpacing + 'px',
														'font-weight': _vm.formular.nutzungsartNichtWohnbau.schriftart + 'px', }),attrs:{"rows":"2","disabled":_vm.formular.nutzungsartNichtWohnbau.isDisabled==true || _vm.formular.nutzungsartNichtWohnbau.isDisabled=='true',"id":"nutzungsartNichtWohnbau"},domProps:{"value":(_vm.formular.nutzungsartNichtWohnbau.text)},on:{"focus":function($event){_vm.formular.nutzungsartNichtWohnbau.showPop=true},"blur":function($event){_vm.formular.nutzungsartNichtWohnbau.showPop=false},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.nutzungsartNichtWohnbau, "text", $event.target.value)}}}):_vm._e()],1),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5034082) + 'px', 
														top: _vm.gib_hoehe_in_mm(124.4051205) + 'px'})},[_vm._v(" 3 Angaben zum Gebäude 3 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(130.0151667) + 'px'})},[_vm._v(" Bauherr ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(135.0150419) + 'px'})},[_vm._v(" Öffentlicher Bauherr .... 1 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(140.0674694) + 'px'})},[_vm._v(" Unternehmen ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5619271) + 'px', 
														top: _vm.gib_hoehe_in_mm(144.0938926) + 'px'})},[_vm._v(" Wohnungsunternehmen .. 2 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5619271) + 'px', 
														top: _vm.gib_hoehe_in_mm(149.0934151) + 'px'})},[_vm._v(" Immobilienfonds .............. 3 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(154.1469007) + 'px'})},[_vm._v(" Land und Forstwirtschaft, ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(157.6739007) + 'px'})},[_vm._v(" Tierhaltung, Fischerei .... 4 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(162.7273863) + 'px'})},[_vm._v(" Produzierendes ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(166.2543863) + 'px'})},[_vm._v(" Gewerbe .......................... 5 ")]),(_vm.formular.oeffentlBauherr!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(134.5939945) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.oeffentlBauherr.text),callback:function ($$v) {_vm.$set(_vm.formular.oeffentlBauherr, "text", $$v)},expression:"formular.oeffentlBauherr.text"}}):_vm._e(),(_vm.formular.wohnungsunternehmen!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(143.6739033) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.wohnungsunternehmen.text),callback:function ($$v) {_vm.$set(_vm.formular.wohnungsunternehmen, "text", $$v)},expression:"formular.wohnungsunternehmen.text"}}):_vm._e(),(_vm.formular.immobilienfond!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(148.6727204) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.immobilienfond.text),callback:function ($$v) {_vm.$set(_vm.formular.immobilienfond, "text", $$v)},expression:"formular.immobilienfond.text"}}):_vm._e(),(_vm.formular.landUndForstwirtschaft!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(157.2539114) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.landUndForstwirtschaft.text),callback:function ($$v) {_vm.$set(_vm.formular.landUndForstwirtschaft, "text", $$v)},expression:"formular.landUndForstwirtschaft.text"}}):_vm._e(),(_vm.formular.produzierendeGew!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(165.8340443) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.produzierendeGew.text),callback:function ($$v) {_vm.$set(_vm.formular.produzierendeGew, "text", $$v)},expression:"formular.produzierendeGew.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(134.0687478) + 'px'})},[_vm._v(" Handel, Kreditinstitute und ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(137.5957478) + 'px'})},[_vm._v(" Versicherungsgewerbe, ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(141.1227478) + 'px'})},[_vm._v(" Dienstleistungen sowie ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(144.6497478) + 'px'})},[_vm._v(" Verkehr und Nachrich ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(148.1767478) + 'px'})},[_vm._v(" tenübermittlung ............... 6 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(153.7035568) + 'px'})},[_vm._v(" Privater Haushalt .......... 7 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(159.2300131) + 'px'})},[_vm._v(" Organisation ohne ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.551281) + 'px', 
														top: _vm.gib_hoehe_in_mm(162.7570131) + 'px'})},[_vm._v(" Erwerbszweck ............... 8 ")]),(_vm.formular.orgiOhneErwerbzweck!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(192.1537816) + 'px',top: _vm.gib_hoehe_in_mm(162.3370238) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.orgiOhneErwerbzweck.text),callback:function ($$v) {_vm.$set(_vm.formular.orgiOhneErwerbzweck, "text", $$v)},expression:"formular.orgiOhneErwerbzweck.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.4053891) + 'px', 
														top: _vm.gib_hoehe_in_mm(159.5834185) + 'px'})},[_vm._v(" Bei allen ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.4053891) + 'px', 
														top: _vm.gib_hoehe_in_mm(161.9398072) + 'px'})},[_vm._v(" Baumaß ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.4053891) + 'px', 
														top: _vm.gib_hoehe_in_mm(164.2965486) + 'px'})},[_vm._v(" nahmen ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(173.3076809) + 'px'})},[_vm._v(" Wohngebäude ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(144.3167279) + 'px', 
														top: _vm.gib_hoehe_in_mm(173.3076809) + 'px'})},[_vm._v(" (ohne Wohnheim) ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(114.5601343) + 'px', 
														top: _vm.gib_hoehe_in_mm(178.8066266) + 'px'})},[_vm._v(" ohne Eigentumswohnungen ............................................... 1 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(114.5629559) + 'px', 
														top: _vm.gib_hoehe_in_mm(183.805091) + 'px'})},[_vm._v(" mit Eigentumswohnungen ................................................... 2 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(188.8042608) + 'px'})},[_vm._v(" Wohnheim ................................................................................. 3 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(193.8577464) + 'px'})},[_vm._v(" Nichtwohngebäude Bitte Nutzungsart angeben ")]),(_vm.formular.handel!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(192.1537816) + 'px',top: _vm.gib_hoehe_in_mm(147.7571112) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.handel.text),callback:function ($$v) {_vm.$set(_vm.formular.handel, "text", $$v)},expression:"formular.handel.text"}}):_vm._e(),(_vm.formular.privaterHaushalt!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(192.1537816) + 'px',top: _vm.gib_hoehe_in_mm(153.2828621) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.privaterHaushalt.text),callback:function ($$v) {_vm.$set(_vm.formular.privaterHaushalt, "text", $$v)},expression:"formular.privaterHaushalt.text"}}):_vm._e(),(_vm.formular.ohneEigentumswhg!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(192.1537816) + 'px',top: _vm.gib_hoehe_in_mm(178.3862846) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.ohneEigentumswhg.text),callback:function ($$v) {_vm.$set(_vm.formular.ohneEigentumswhg, "text", $$v)},expression:"formular.ohneEigentumswhg.text"}}):_vm._e(),(_vm.formular.mitEigentumswhg!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(192.1537816) + 'px',top: _vm.gib_hoehe_in_mm(183.3851017) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.mitEigentumswhg.text),callback:function ($$v) {_vm.$set(_vm.formular.mitEigentumswhg, "text", $$v)},expression:"formular.mitEigentumswhg.text"}}):_vm._e(),(_vm.formular.wohnheim!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(192.1537816) + 'px',top: _vm.gib_hoehe_in_mm(188.3842715) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.wohnheim.text),callback:function ($$v) {_vm.$set(_vm.formular.wohnheim, "text", $$v)},expression:"formular.wohnheim.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.1996727) + 'px', 
														top: _vm.gib_hoehe_in_mm(221.9397204) + 'px'})},[_vm._v(" Wurde ein Abgangsbogen ausgestellt ? ............... ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.1989673) + 'px', 
														top: _vm.gib_hoehe_in_mm(228.9916042) + 'px'})},[_vm._v(" Bei Wiederaufbau, Ersatzbau, Wiederherstellung ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.1989673) + 'px', 
														top: _vm.gib_hoehe_in_mm(234.0447371) + 'px'})},[_vm._v(" In welchem Jahr wurde das Gebäude ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.3929523) + 'px', 
														top: _vm.gib_hoehe_in_mm(237.7946435) + 'px'})},[_vm._v(" (Gebäudeteil) abgebrochen, zerstört o.Ä.? ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(75.8541309) + 'px', 
														top: _vm.gib_hoehe_in_mm(238.0619901) + 'px'})},[_vm._v(" ........ ")]),(_vm.formular.Abbruch_Jahr)?_c('b-popover',{ref:"Abbruch_Jahr",attrs:{"show":_vm.formular.Abbruch_Jahr.showPop==true,"target":"Abbruch_Jahr"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.Abbruch_Jahr.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.Abbruch_Jahr.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("Abbruch_Jahr", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("Abbruch_Jahr", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.Abbruch_Jahr!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.Abbruch_Jahr.text),expression:"formular.Abbruch_Jahr.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(16.3848071) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(86.1437364) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(236.9725119) + 'px', 
		
														'font-size': _vm.formular.Abbruch_Jahr.size + 'px', 
														'text-align': _vm.formular.Abbruch_Jahr.schriftausrichtung, 
														'letter-spacing': _vm.formular.Abbruch_Jahr.letterSpacing + 'px',
														'font-weight': _vm.formular.Abbruch_Jahr.schriftart }),attrs:{"id":"Abbruch_Jahr","type":"text","disabled":_vm.formular.Abbruch_Jahr.isDisabled==true || _vm.formular.Abbruch_Jahr.isDisabled==true},domProps:{"value":(_vm.formular.Abbruch_Jahr.text)},on:{"focus":function($event){_vm.formular.Abbruch_Jahr.showPop=true},"blur":function($event){_vm.formular.Abbruch_Jahr.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.Abbruch_Jahr.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.Abbruch_Jahr, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.2584336) + 'px', 
														top: _vm.gib_hoehe_in_mm(235.634356) + 'px'})},[_vm._v(" Bei ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.2584336) + 'px', 
														top: _vm.gib_hoehe_in_mm(237.9910974) + 'px'})},[_vm._v(" Baumaß ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.2584336) + 'px', 
														top: _vm.gib_hoehe_in_mm(240.3478388) + 'px'})},[_vm._v(" nahmen ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.1996727) + 'px', 
														top: _vm.gib_hoehe_in_mm(246.6128489) + 'px'})},[_vm._v(" Wurde ein Abgangsbogen ausgestellt ? .............. ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(246.8064812) + 'px'})},[_vm._v(" Leichtbeton/Bims ............ 4 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(246.8064812) + 'px'})},[_vm._v(" Sonstiges ........................ 8 ")]),(_vm.formular.leichtbeton!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(246.3864919) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.leichtbeton.text),callback:function ($$v) {_vm.$set(_vm.formular.leichtbeton, "text", $$v)},expression:"formular.leichtbeton.text"}}):_vm._e(),(_vm.formular.sonstigesMaterial!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(246.3864919) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.sonstigesMaterial.text),callback:function ($$v) {_vm.$set(_vm.formular.sonstigesMaterial, "text", $$v)},expression:"formular.sonstigesMaterial.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.6148321) + 'px', 
														top: _vm.gib_hoehe_in_mm(206.6311296) + 'px'})},[_vm._v(" (z.B. Bankgebäude, Werkhalle, Kirche, Schule) ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(210.7591304) + 'px'})},[_vm._v(" Haustyp des Wohngebäudes ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(89.5713393) + 'px', 
														top: _vm.gib_hoehe_in_mm(216.9927502) + 'px'})},[_vm._v(" Ja Nein ")]),(_vm.formular.abgangsbogen_ja!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(89.2144069) + 'px',top: _vm.gib_hoehe_in_mm(221.5197311) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.abgangsbogen_ja.text),callback:function ($$v) {_vm.$set(_vm.formular.abgangsbogen_ja, "text", $$v)},expression:"formular.abgangsbogen_ja.text"}}):_vm._e(),(_vm.formular.abgangsbogen_nein!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(98.1285467) + 'px',top: _vm.gib_hoehe_in_mm(221.5197311) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.abgangsbogen_nein.text),callback:function ($$v) {_vm.$set(_vm.formular.abgangsbogen_nein, "text", $$v)},expression:"formular.abgangsbogen_nein.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(215.7583002) + 'px'})},[_vm._v(" Einzelhaus ....................... 1 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(215.7583002) + 'px'})},[_vm._v(" Gereihtes Haus .............. 3 ")]),(_vm.formular.einzelhaus!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(215.3383109) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.einzelhaus.text),callback:function ($$v) {_vm.$set(_vm.formular.einzelhaus, "text", $$v)},expression:"formular.einzelhaus.text"}}):_vm._e(),(_vm.formular.gereihtesHaus!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(215.3383109) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.gereihtesHaus.text),callback:function ($$v) {_vm.$set(_vm.formular.gereihtesHaus, "text", $$v)},expression:"formular.gereihtesHaus.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(220.7571173) + 'px'})},[_vm._v(" Doppelhaushälfte ........... 2 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(220.7571173) + 'px'})},[_vm._v(" Sonstiger Haustyp ......... 4 ")]),(_vm.formular.doppelhaushaelfte!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(220.337128) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.doppelhaushaelfte.text),callback:function ($$v) {_vm.$set(_vm.formular.doppelhaushaelfte, "text", $$v)},expression:"formular.doppelhaushaelfte.text"}}):_vm._e(),(_vm.formular.sonstigerHaustyp!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(220.337128) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.sonstigerHaustyp.text),callback:function ($$v) {_vm.$set(_vm.formular.sonstigerHaustyp, "text", $$v)},expression:"formular.sonstigerHaustyp.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(226.8105074) + 'px'})},[_vm._v(" Überwiegend verwendeter Baustoff/Tragkonstruktion ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(231.8103826) + 'px'})},[_vm._v(" Ziegel ............................... 1 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(231.8093245) + 'px'})},[_vm._v(" Stahl ................................ 5 ")]),(_vm.formular.ziegel!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(231.3896879) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.ziegel.text),callback:function ($$v) {_vm.$set(_vm.formular.ziegel, "text", $$v)},expression:"formular.ziegel.text"}}):_vm._e(),(_vm.formular.stahl!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(231.3896879) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.stahl.text),callback:function ($$v) {_vm.$set(_vm.formular.stahl, "text", $$v)},expression:"formular.stahl.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(236.8081416) + 'px'})},[_vm._v(" Kalksandstein .................. 2 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(236.8081416) + 'px'})},[_vm._v(" Stahlbeton ...................... 6 ")]),(_vm.formular.porenbeton!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(241.3866167) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.porenbeton.text),callback:function ($$v) {_vm.$set(_vm.formular.porenbeton, "text", $$v)},expression:"formular.porenbeton.text"}}):_vm._e(),(_vm.formular.holz!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(241.3866167) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.holz.text),callback:function ($$v) {_vm.$set(_vm.formular.holz, "text", $$v)},expression:"formular.holz.text"}}):_vm._e(),(_vm.formular.kalksandstein!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(236.388505) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.kalksandstein.text),callback:function ($$v) {_vm.$set(_vm.formular.kalksandstein, "text", $$v)},expression:"formular.kalksandstein.text"}}):_vm._e(),(_vm.formular.stahlbeton!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(236.388505) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.stahlbeton.text),callback:function ($$v) {_vm.$set(_vm.formular.stahlbeton, "text", $$v)},expression:"formular.stahlbeton.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(241.8069587) + 'px'})},[_vm._v(" Porenbeton ...................... 3 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(241.8069587) + 'px'})},[_vm._v(" Holz ................................. 7 ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(197.6929351) + 'px', 
														top: _vm.gib_hoehe_in_mm(232.1588502) + 'px'})},[_vm._v(" Nur bei ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(197.6929351) + 'px', 
														top: _vm.gib_hoehe_in_mm(234.5152389) + 'px'})},[_vm._v(" Errichtung ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(197.6929351) + 'px', 
														top: _vm.gib_hoehe_in_mm(236.8719803) + 'px'})},[_vm._v(" eines ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(197.6929351) + 'px', 
														top: _vm.gib_hoehe_in_mm(239.2287217) + 'px'})},[_vm._v(" neuen ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(197.6929351) + 'px', 
														top: _vm.gib_hoehe_in_mm(241.5851104) + 'px'})},[_vm._v(" Gebäudes ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(89.5713393) + 'px', 
														top: _vm.gib_hoehe_in_mm(241.6849245) + 'px'})},[_vm._v(" Ja Nein ")]),(_vm.formular.wa_abgangsbogen_ja!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(89.2144069) + 'px',top: _vm.gib_hoehe_in_mm(246.1925069) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.wa_abgangsbogen_ja.text),callback:function ($$v) {_vm.$set(_vm.formular.wa_abgangsbogen_ja, "text", $$v)},expression:"formular.wa_abgangsbogen_ja.text"}}):_vm._e(),(_vm.formular.wa_abgangsbogen_nein!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(98.1285467) + 'px',top: _vm.gib_hoehe_in_mm(246.1925069) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.wa_abgangsbogen_nein.text),callback:function ($$v) {_vm.$set(_vm.formular.wa_abgangsbogen_nein, "text", $$v)},expression:"formular.wa_abgangsbogen_nein.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(252.8595186) + 'px'})},[_vm._v(" Vorwiegende Art der Beheizung ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(257.8593938) + 'px'})},[_vm._v(" Fernheizung .................... 1 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(257.8586884) + 'px'})},[_vm._v(" Etagenheizung ............... 4 ")]),(_vm.formular.ferneheizung!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(257.4379937) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.ferneheizung.text),callback:function ($$v) {_vm.$set(_vm.formular.ferneheizung, "text", $$v)},expression:"formular.ferneheizung.text"}}):_vm._e(),(_vm.formular.etagenheizung!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(257.4379937) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.etagenheizung.text),callback:function ($$v) {_vm.$set(_vm.formular.etagenheizung, "text", $$v)},expression:"formular.etagenheizung.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(262.8575055) + 'px'})},[_vm._v(" Blockheizung ................... 2 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(262.8575055) + 'px'})},[_vm._v(" Einzelraumheizung ........ 5 ")]),(_vm.formular.blockheizung!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(262.4368108) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.blockheizung.text),callback:function ($$v) {_vm.$set(_vm.formular.blockheizung, "text", $$v)},expression:"formular.blockheizung.text"}}):_vm._e(),(_vm.formular.einzelraumhzg!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(262.4368108) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.einzelraumhzg.text),callback:function ($$v) {_vm.$set(_vm.formular.einzelraumhzg, "text", $$v)},expression:"formular.einzelraumhzg.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(110.5612217) + 'px', 
														top: _vm.gib_hoehe_in_mm(267.8563226) + 'px'})},[_vm._v(" Zentralheizung ................ 3 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(155.9671143) + 'px', 
														top: _vm.gib_hoehe_in_mm(267.8563226) + 'px'})},[_vm._v(" Keine Heizung ................ 6 ")]),(_vm.formular.zentralheizung!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(147.3637032) + 'px',top: _vm.gib_hoehe_in_mm(267.4359806) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.zentralheizung.text),callback:function ($$v) {_vm.$set(_vm.formular.zentralheizung, "text", $$v)},expression:"formular.zentralheizung.text"}}):_vm._e(),(_vm.formular.keinehzg!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(191.9700249) + 'px',top: _vm.gib_hoehe_in_mm(267.4359806) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.keinehzg.text),callback:function ($$v) {_vm.$set(_vm.formular.keinehzg, "text", $$v)},expression:"formular.keinehzg.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(195.833148) + 'px', 
														top: _vm.gib_hoehe_in_mm(279.5924151) + 'px'})},[_vm._v(" Seite 1 ")]),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(154.9672098) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(32.1226911) + 'px', 
													top: _vm.gib_hoehe_in_mm(23.1185744) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(105.6227163) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.1412655) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1050482) + 'px', 
													width: _vm.spalte_breit_mm(1.0577473) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(122.420554) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(105.1627955) + 'px', 
													width: _vm.spalte_breit_mm(104.4193039) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(122.420554) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(197.0908762) + 'px', 
													width: _vm.spalte_breit_mm(12.4912232) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(208.7315345) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(197.0908762) + 'px', 
													width: _vm.spalte_breit_mm(12.4912232) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(271.3819882) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.6155668) + 'px', 
													width: _vm.spalte_breit_mm(90.0333763) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(101.0352949) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.6155668) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(100.0886481) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.5939219) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(100.08759) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.6155668) + 'px', 
													width: _vm.spalte_breit_mm(90.0333763) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.2741759) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.6155668) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0469995) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3271764) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.5939219) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3261183) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(110.6148321) + 'px', 
													width: _vm.spalte_breit_mm(69.9844975) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(204.9354244) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(180.5993296) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.099427) + 'px', 
													top: _vm.gib_hoehe_in_mm(198.9359974) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(110.6148321) + 'px', 
													width: _vm.spalte_breit_mm(69.9844975) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(198.9359974) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(110.6148321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.099427) + 'px', 
													top: _vm.gib_hoehe_in_mm(198.9359974) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(4.1810917) + 'px', 
													top: _vm.gib_hoehe_in_mm(23.1185744) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.8968155) + 'px', 
													top: _vm.gib_hoehe_in_mm(27.2000188) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(11.1384519) + 'px', 
													top: _vm.gib_hoehe_in_mm(30.9968343) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(9.1389956) + 'px', 
													top: _vm.gib_hoehe_in_mm(42.0352862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(39.7279612) + 'px', 
													top: _vm.gib_hoehe_in_mm(51.0742818) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.1533901) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.702243) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.1807097) + 'px', 
													top: _vm.gib_hoehe_in_mm(96.7556331) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.6805811) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.8363428) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.1531991) + 'px', 
													top: _vm.gib_hoehe_in_mm(112.4169239) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.0981779) + 'px', 
													top: _vm.gib_hoehe_in_mm(120.470123) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.0981779) + 'px', 
													top: _vm.gib_hoehe_in_mm(128.4683009) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.0981779) + 'px', 
													top: _vm.gib_hoehe_in_mm(136.4664788) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(11.6794937) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.4646567) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.7323376) + 'px', 
													width: _vm.spalte_breit_mm(40.7886969) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.4418831) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.7323376) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.4952363) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.7323376) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.4952363) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(47.5210345) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.4952363) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.6776691) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0469995) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.2010173) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(19.4623387) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(23.7240128) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(27.9856869) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.2470083) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(36.5086824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(40.7703565) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(45.0320306) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(49.293352) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.5550261) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(57.8167002) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(62.0783743) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(66.3396957) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(70.6013698) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.8630439) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(79.1243653) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(83.3860394) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.6477135) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(91.9093876) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0469995) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(10.9393432) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.5343274) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.6776691) + 'px', 
													width: _vm.spalte_breit_mm(85.2317185) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(47.4813269) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1785845) + 'px', 
													width: _vm.spalte_breit_mm(68.9852984) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(76.1526626) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.2314895) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.2056631) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0958118) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.2056631) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1785845) + 'px', 
													width: _vm.spalte_breit_mm(68.9852984) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(69.6541651) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.2314895) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.7071656) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0958118) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.7071656) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1785845) + 'px', 
													width: _vm.spalte_breit_mm(68.9852984) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(89.1496576) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.2314895) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.2030108) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0958118) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.2030108) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1785845) + 'px', 
													width: _vm.spalte_breit_mm(68.9852984) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(82.6511601) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.2314895) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(81.7041606) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0958118) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(81.7041606) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9342589) + 'px', 
													width: _vm.spalte_breit_mm(56.9765688) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.2837574) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.3371106) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.854043) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.3371106) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.7543906) + 'px', 
													width: _vm.spalte_breit_mm(11.9015088) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.2837574) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.7635608) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.3371106) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.6558994) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.3371106) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.7759704) + 'px', 
													width: _vm.spalte_breit_mm(56.9197841) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.3641144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.8186471) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.4171149) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.6957545) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0469995) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.4171149) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9677654) + 'px', 
													width: _vm.spalte_breit_mm(11.9135006) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.3641144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.4171149) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(42.8692742) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.4171149) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(56.6238688) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(127.4154914) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.4688446) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.5546007) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.4688446) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.5138492) + 'px', 
													width: _vm.spalte_breit_mm(12.0750372) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(127.4154914) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.5671069) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.4688446) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.5663722) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.4688446) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.5652848) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.4688446) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.5649028) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.4688446) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(56.6238688) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(135.4136693) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4670225) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.5546007) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4670225) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.5138492) + 'px', 
													width: _vm.spalte_breit_mm(12.0750372) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(135.4136693) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.5671069) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4670225) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.5663722) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4670225) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.5652848) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4670225) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.5649028) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4670225) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(56.6238688) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(143.4118472) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(30.9769356) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(142.4652004) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.5546007) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(142.4652004) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.6834979) + 'px', 
													width: _vm.spalte_breit_mm(12.0743318) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(143.4118472) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.7364029) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(142.4652004) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.7353155) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(142.4652004) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7345808) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(142.4652004) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.7338461) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(142.4652004) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.6644738) + 'px', 
													width: _vm.spalte_breit_mm(8.1043406) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.9913409) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.7173788) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(78.7162914) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.7155567) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(85.7678225) + 'px', 
													width: _vm.spalte_breit_mm(16.1028712) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.9913409) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(85.8210802) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.8199928) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.8192581) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8181707) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.8177887) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(154.0446941) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(0.6098183) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(1.5275437) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(3.826795) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.126399) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(8.426003) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(10.725607) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(13.0248583) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.3244623) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(17.6240663) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(19.9233176) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(22.2229216) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(24.5225256) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(26.8217769) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(29.1213809) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.4209849) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(33.7205889) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(36.0198402) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(38.3194442) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(40.6190482) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(42.9182995) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(45.2179035) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(47.5175075) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(49.8167588) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(52.1163628) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.4159668) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(56.7152181) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(59.0148221) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(61.3144261) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(63.6140301) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(65.9132814) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(68.2128854) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(70.5124894) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(72.8117407) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(75.1113447) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(77.4109487) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(79.7102) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.009804) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(84.309408) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(86.6086593) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(88.9082633) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(91.2078673) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.5074713) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(95.8067226) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.1063266) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(100.4059306) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.7055346) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(105.0051386) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(107.3043899) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(109.6039939) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(111.9035979) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(114.2028492) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(116.5024532) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(118.8020572) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(121.1013085) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(123.4009125) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(125.7005165) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(128.0001205) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(130.2993718) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(132.5989758) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(134.8985798) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(137.1978311) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(139.4974351) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(141.7970391) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(144.0962904) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(146.3958944) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.6954984) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(150.9951024) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(153.2943537) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(155.5939577) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(157.8935617) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.192813) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(162.492417) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(164.792021) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.0912723) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(169.3908763) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.6904803) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(173.9897316) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(176.2893356) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.5889396) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(180.8885436) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.1877949) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(185.4873989) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.7870029) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0862542) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(192.3858582) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(194.6854622) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.9847135) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(199.2843175) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(201.5839215) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(203.8835255) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(206.1827768) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(208.4823808) + 'px', 
													width: _vm.spalte_breit_mm(1.0997186) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6420127) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.1085017) + 'px', 
													top: _vm.gib_hoehe_in_mm(156.3400657) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4104422) + 'px', 
													top: _vm.gib_hoehe_in_mm(163.4765975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.3120389) + 'px', 
													top: _vm.gib_hoehe_in_mm(166.7870397) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.1531329) + 'px', 
													top: _vm.gib_hoehe_in_mm(169.9990786) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.598593) + 'px', 
													top: _vm.gib_hoehe_in_mm(175.0522115) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.0459121) + 'px', 
													top: _vm.gib_hoehe_in_mm(180.5508045) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(103.8415813) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(163.4314519) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.5460407) + 'px', 
													top: _vm.gib_hoehe_in_mm(185.6885854) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.1538383) + 'px', 
													top: _vm.gib_hoehe_in_mm(191.1346261) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.6801329) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.1884644) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(4.1539338) + 'px', 
													top: _vm.gib_hoehe_in_mm(204.7685973) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.2043406) + 'px', 
													top: _vm.gib_hoehe_in_mm(208.8225311) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(9.1389956) + 'px', 
													top: _vm.gib_hoehe_in_mm(216.9268717) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.1525892) + 'px', 
													top: _vm.gib_hoehe_in_mm(225.9658673) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.6801329) + 'px', 
													top: _vm.gib_hoehe_in_mm(233.0195146) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(10.1385474) + 'px', 
													top: _vm.gib_hoehe_in_mm(241.5996475) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.21415) + 'px', 
													top: _vm.gib_hoehe_in_mm(251.6381949) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.2137973) + 'px', 
													top: _vm.gib_hoehe_in_mm(256.7523449) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(103.9593831) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(18.450981) + 'px', 
													top: _vm.gib_hoehe_in_mm(261.8661422) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(15.3554999) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(185.6356804) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(15.3554999) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(280.2171232) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.4733017) + 'px', 
													width: _vm.spalte_breit_mm(86.4813346) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(215.8740622) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.9546363) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.0987216) + 'px', 
													top: _vm.gib_hoehe_in_mm(209.8753406) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.4733017) + 'px', 
													width: _vm.spalte_breit_mm(86.4813346) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(209.8753406) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.4733017) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.0987216) + 'px', 
													top: _vm.gib_hoehe_in_mm(209.8753406) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(85.8937364) + 'px', 
													width: _vm.spalte_breit_mm(15.9970612) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(240.546838) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(85.8937364) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0469995) + 'px', 
													top: _vm.gib_hoehe_in_mm(239.5998385) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.8930017) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(239.5998385) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.892267) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(239.5998385) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8911796) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(239.5998385) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.8907976) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0469995) + 'px', 
													top: _vm.gib_hoehe_in_mm(239.5998385) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(209.4642976) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(15.4060835) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.4733017) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(116.8405257) + 'px', 
													top: _vm.gib_hoehe_in_mm(163.4765975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(209.5820994) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(149.0085292) + 'px', 
													top: _vm.gib_hoehe_in_mm(122.473459) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(197.0908762) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(149.0085292) + 'px', 
													top: _vm.gib_hoehe_in_mm(122.473459) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(205.6868806) + 'px', 
													width: _vm.spalte_breit_mm(3.8952188) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(0.12359249999997) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(209.5820994) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4319569) + 'px', 
													top: _vm.gib_hoehe_in_mm(0.12359249999997) + 'px'})})],1),_c('div',{staticStyle:{"font-family":"Arial, Verdana, sans-serif","border":"solid 1px black","position":"relative","width":"909px","height":"1286px","overflow":"hidden","background-color":"white","margin":"0 auto 10px"}},[_c('div',{style:({
														fontSize:'15px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(25.7333447) + 'px', 
														top: _vm.gib_hoehe_in_mm(18.1186228) + 'px'})},[_vm._v(" Angaben zum Gebäude ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.6047286) + 'px', 
														top: _vm.gib_hoehe_in_mm(18.1186228) + 'px'})},[_vm._v(" 4 Größe des Bauvorhabens 4 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(23.728669) + 'px'})},[_vm._v(" Verwendete Energie (Bitte jeweils eine Position ankreuzen.) ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(23.728669) + 'px'})},[_vm._v(" Werte ohne Kommastellen angeben. ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(31.3071339) + 'px'})},[_vm._v(" Heizung ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(40.567554) + 'px', 
														top: _vm.gib_hoehe_in_mm(31.6069289) + 'px'})},[_vm._v(" Primär Sekundär ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(83.4678658) + 'px', 
														top: _vm.gib_hoehe_in_mm(31.3984832) + 'px'})},[_vm._v(" Primär Sekundär ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(61.613163) + 'px', 
														top: _vm.gib_hoehe_in_mm(29.3351882) + 'px'})},[_vm._v(" Warmwasser ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(61.613163) + 'px', 
														top: _vm.gib_hoehe_in_mm(32.8621882) + 'px'})},[_vm._v(" bereitung ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(29.587016) + 'px'})},[_vm._v(" Rauminhalt Brutto in cbm (DIN 277) ... 01 ")]),(_vm.formular.cbm)?_c('b-popover',{ref:"cbm",attrs:{"show":_vm.formular.cbm.showPop==true,"target":"cbm"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.cbm.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.cbm.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("cbm", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("cbm", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.cbm!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.cbm.text),expression:"formular.cbm.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(28.9934794) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(167.7444084) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(29.406093) + 'px', 
		
														'font-size': _vm.formular.cbm.size + 'px', 
														'text-align': _vm.formular.cbm.schriftausrichtung, 
														'letter-spacing': _vm.formular.cbm.letterSpacing + 'px',
														'font-weight': _vm.formular.cbm.schriftart }),attrs:{"id":"cbm","type":"text","disabled":_vm.formular.cbm.isDisabled==true || _vm.formular.cbm.isDisabled==true},domProps:{"value":(_vm.formular.cbm.text)},on:{"focus":function($event){_vm.formular.cbm.showPop=true},"blur":function($event){_vm.formular.cbm.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.cbm.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.cbm, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(200.2062753) + 'px', 
														top: _vm.gib_hoehe_in_mm(28.3109474) + 'px'})},[_vm._v(" nur ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(200.2062753) + 'px', 
														top: _vm.gib_hoehe_in_mm(30.6673361) + 'px'})},[_vm._v(" Neubau ")]),(_vm.formular.hzg1!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.220049) + 'px',top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg1.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg1, "text", $$v)},expression:"formular.hzg1.text"}}):_vm._e(),(_vm.formular.hzg13!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3725185) + 'px',top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg13.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg13, "text", $$v)},expression:"formular.hzg13.text"}}):_vm._e(),(_vm.formular.hzg25!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1616929) + 'px',top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg25.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg25, "text", $$v)},expression:"formular.hzg25.text"}}):_vm._e(),(_vm.formular.hzg37!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.659103) + 'px',top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg37.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg37, "text", $$v)},expression:"formular.hzg37.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(37.7255685) + 'px'})},[_vm._v(" Anzahl der Vollgeschosse (laut LBO ) ...................... ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(180.0798025) + 'px', 
														top: _vm.gib_hoehe_in_mm(38.2821291) + 'px'})},[_vm._v(" 02 ")]),(_vm.formular.vollgesch)?_c('b-popover',{ref:"vollgesch",attrs:{"show":_vm.formular.vollgesch.showPop==true,"target":"vollgesch"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.vollgesch.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.vollgesch.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("vollgesch", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("vollgesch", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.vollgesch!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.vollgesch.text),expression:"formular.vollgesch.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(183.7848517) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(36.904495) + 'px', 
		
														'font-size': _vm.formular.vollgesch.size + 'px', 
														'text-align': _vm.formular.vollgesch.schriftausrichtung, 
														'letter-spacing': _vm.formular.vollgesch.letterSpacing + 'px',
														'font-weight': _vm.formular.vollgesch.schriftart }),attrs:{"id":"vollgesch","type":"text","disabled":_vm.formular.vollgesch.isDisabled==true || _vm.formular.vollgesch.isDisabled==true},domProps:{"value":(_vm.formular.vollgesch.text)},on:{"focus":function($event){_vm.formular.vollgesch.showPop=true},"blur":function($event){_vm.formular.vollgesch.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.vollgesch.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.vollgesch, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.identnummer_Seite2)?_c('b-popover',{ref:"identnummer_Seite2",attrs:{"show":_vm.formular.identnummer_Seite2.showPop==true,"target":"identnummer_Seite2"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.identnummer_Seite2.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.identnummer_Seite2.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("identnummer_Seite2", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("identnummer_Seite2", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.identnummer_Seite2!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.identnummer_Seite2.text),expression:"formular.identnummer_Seite2.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(39.2771533) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(163.003415) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(9.6704118) + 'px', 
		
														'font-size': _vm.formular.identnummer_Seite2.size + 'px', 
														'text-align': _vm.formular.identnummer_Seite2.schriftausrichtung, 
														'letter-spacing': _vm.formular.identnummer_Seite2.letterSpacing + 'px',
														'font-weight': _vm.formular.identnummer_Seite2.schriftart }),attrs:{"id":"identnummer_Seite2","type":"text","disabled":_vm.formular.identnummer_Seite2.isDisabled==true || _vm.formular.identnummer_Seite2.isDisabled==true},domProps:{"value":(_vm.formular.identnummer_Seite2.text)},on:{"focus":function($event){_vm.formular.identnummer_Seite2.showPop=true},"blur":function($event){_vm.formular.identnummer_Seite2.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.identnummer_Seite2.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.identnummer_Seite2, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(162.4864211) + 'px', 
														top: _vm.gib_hoehe_in_mm(13.7359726) + 'px'})},[_vm._v(" Identifikationsnummer ")]),(_vm.formular.hzg10!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.1749034) + 'px',top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg10.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg10, "text", $$v)},expression:"formular.hzg10.text"}}):_vm._e(),(_vm.formular.hzg22!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3273729) + 'px',top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg22.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg22, "text", $$v)},expression:"formular.hzg22.text"}}):_vm._e(),(_vm.formular.hzg34!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1165473) + 'px',top: _vm.gib_hoehe_in_mm(99.1751551) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg34.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg34, "text", $$v)},expression:"formular.hzg34.text"}}):_vm._e(),(_vm.formular.hzg46!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.6139574) + 'px',top: _vm.gib_hoehe_in_mm(99.1751551) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg46.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg46, "text", $$v)},expression:"formular.hzg46.text"}}):_vm._e(),(_vm.formular.hzg11!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.220049) + 'px',top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg11.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg11, "text", $$v)},expression:"formular.hzg11.text"}}):_vm._e(),(_vm.formular.hzg23!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3725185) + 'px',top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg23.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg23, "text", $$v)},expression:"formular.hzg23.text"}}):_vm._e(),(_vm.formular.hzg35!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1616929) + 'px',top: _vm.gib_hoehe_in_mm(104.6733954) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg35.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg35, "text", $$v)},expression:"formular.hzg35.text"}}):_vm._e(),(_vm.formular.hzg47!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.659103) + 'px',top: _vm.gib_hoehe_in_mm(104.6733954) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg47.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg47, "text", $$v)},expression:"formular.hzg47.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(101.4912596) + 'px'})},[_vm._v(" 1 Raum ...................... ")]),(_vm.formular.raum1neu)?_c('b-popover',{ref:"raum1neu",attrs:{"show":_vm.formular.raum1neu.showPop==true,"target":"raum1neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum1neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum1neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum1neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum1neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum1neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum1neu.text),expression:"formular.raum1neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(100.6694807) + 'px', 
		
														'font-size': _vm.formular.raum1neu.size + 'px', 
														'text-align': _vm.formular.raum1neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum1neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum1neu.schriftart }),attrs:{"id":"raum1neu","type":"text","disabled":_vm.formular.raum1neu.isDisabled==true || _vm.formular.raum1neu.isDisabled==true},domProps:{"value":(_vm.formular.raum1neu.text)},on:{"focus":function($event){_vm.formular.raum1neu.showPop=true},"blur":function($event){_vm.formular.raum1neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum1neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum1neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum1alt)?_c('b-popover',{ref:"raum1alt",attrs:{"show":_vm.formular.raum1alt.showPop==true,"target":"raum1alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum1alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum1alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum1alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum1alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum1alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum1alt.text),expression:"formular.raum1alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(100.6694807) + 'px', 
		
														'font-size': _vm.formular.raum1alt.size + 'px', 
														'text-align': _vm.formular.raum1alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum1alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum1alt.schriftart }),attrs:{"id":"raum1alt","type":"text","disabled":_vm.formular.raum1alt.isDisabled==true || _vm.formular.raum1alt.isDisabled==true},domProps:{"value":(_vm.formular.raum1alt.text)},on:{"focus":function($event){_vm.formular.raum1alt.showPop=true},"blur":function($event){_vm.formular.raum1alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum1alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum1alt, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.hzg12!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.220049) + 'px',top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg12.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg12, "text", $$v)},expression:"formular.hzg12.text"}}):_vm._e(),(_vm.formular.hzg24!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3725185) + 'px',top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg24.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg24, "text", $$v)},expression:"formular.hzg24.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(110.708016) + 'px'})},[_vm._v(" Sonst. Energie .. 12 ")]),(_vm.formular.hzg36!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1616929) + 'px',top: _vm.gib_hoehe_in_mm(110.1723411) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg36.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg36, "text", $$v)},expression:"formular.hzg36.text"}}):_vm._e(),(_vm.formular.hzg48!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.659103) + 'px',top: _vm.gib_hoehe_in_mm(110.1723411) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg48.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg48, "text", $$v)},expression:"formular.hzg48.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(108.9896616) + 'px'})},[_vm._v(" 2 Räumen ................. ")]),(_vm.formular.raum2neu)?_c('b-popover',{ref:"raum2neu",attrs:{"show":_vm.formular.raum2neu.showPop==true,"target":"raum2neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum2neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum2neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum2neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum2neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum2neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum2neu.text),expression:"formular.raum2neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(108.1678827) + 'px', 
		
														'font-size': _vm.formular.raum2neu.size + 'px', 
														'text-align': _vm.formular.raum2neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum2neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum2neu.schriftart }),attrs:{"id":"raum2neu","type":"text","disabled":_vm.formular.raum2neu.isDisabled==true || _vm.formular.raum2neu.isDisabled==true},domProps:{"value":(_vm.formular.raum2neu.text)},on:{"focus":function($event){_vm.formular.raum2neu.showPop=true},"blur":function($event){_vm.formular.raum2neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum2neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum2neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum2alt)?_c('b-popover',{ref:"raum2alt",attrs:{"show":_vm.formular.raum2alt.showPop==true,"target":"raum2alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum2alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum2alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum2alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum2alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum2alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum2alt.text),expression:"formular.raum2alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(108.1678827) + 'px', 
		
														'font-size': _vm.formular.raum2alt.size + 'px', 
														'text-align': _vm.formular.raum2alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum2alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum2alt.schriftart }),attrs:{"id":"raum2alt","type":"text","disabled":_vm.formular.raum2alt.isDisabled==true || _vm.formular.raum2alt.isDisabled==true},domProps:{"value":(_vm.formular.raum2alt.text)},on:{"focus":function($event){_vm.formular.raum2alt.showPop=true},"blur":function($event){_vm.formular.raum2alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum2alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum2alt, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum3neu)?_c('b-popover',{ref:"raum3neu",attrs:{"show":_vm.formular.raum3neu.showPop==true,"target":"raum3neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum3neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum3neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum3neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum3neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum3neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum3neu.text),expression:"formular.raum3neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(115.6662847) + 'px', 
		
														'font-size': _vm.formular.raum3neu.size + 'px', 
														'text-align': _vm.formular.raum3neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum3neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum3neu.schriftart }),attrs:{"id":"raum3neu","type":"text","disabled":_vm.formular.raum3neu.isDisabled==true || _vm.formular.raum3neu.isDisabled==true},domProps:{"value":(_vm.formular.raum3neu.text)},on:{"focus":function($event){_vm.formular.raum3neu.showPop=true},"blur":function($event){_vm.formular.raum3neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum3neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum3neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum3alt)?_c('b-popover',{ref:"raum3alt",attrs:{"show":_vm.formular.raum3alt.showPop==true,"target":"raum3alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum3alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum3alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum3alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum3alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum3alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum3alt.text),expression:"formular.raum3alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(115.6662847) + 'px', 
		
														'font-size': _vm.formular.raum3alt.size + 'px', 
														'text-align': _vm.formular.raum3alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum3alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum3alt.schriftart }),attrs:{"id":"raum3alt","type":"text","disabled":_vm.formular.raum3alt.isDisabled==true || _vm.formular.raum3alt.isDisabled==true},domProps:{"value":(_vm.formular.raum3alt.text)},on:{"focus":function($event){_vm.formular.raum3alt.showPop=true},"blur":function($event){_vm.formular.raum3alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum3alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum3alt, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(116.4309262) + 'px'})},[_vm._v(" Falls Sonstige Energie für Heizung, bitte hier erläutern ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(116.4880636) + 'px'})},[_vm._v(" 3 Räumen ................. ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.9243312) + 'px', 
														top: _vm.gib_hoehe_in_mm(121.4078759) + 'px'})},[_vm._v(" Nur bei ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.9243312) + 'px', 
														top: _vm.gib_hoehe_in_mm(123.7646173) + 'px'})},[_vm._v(" Errichtung ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.9243312) + 'px', 
														top: _vm.gib_hoehe_in_mm(126.1213587) + 'px'})},[_vm._v(" eines ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.9243312) + 'px', 
														top: _vm.gib_hoehe_in_mm(128.4777474) + 'px'})},[_vm._v(" neuen ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(1.9243312) + 'px', 
														top: _vm.gib_hoehe_in_mm(130.8344888) + 'px'})},[_vm._v(" Gebäudes ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.1151202) + 'px', 
														top: _vm.gib_hoehe_in_mm(131.1501553) + 'px'})},[_vm._v(" Falls Sonstige Energie für Warmwasserbereitung, bitte hier erläutern ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(131.4845149) + 'px'})},[_vm._v(" 5 Räumen ................. ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(53.2715264) + 'px'})},[_vm._v(" Nutzfläche ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(56.7985264) + 'px'})},[_vm._v(" ( DIN 277 ohne ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(60.3255264) + 'px'})},[_vm._v(" Wohnfläche ) ............ 03 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(66.3785638) + 'px'})},[_vm._v(" Wohnfläche ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6029358) + 'px', 
														top: _vm.gib_hoehe_in_mm(69.9055638) + 'px'})},[_vm._v(" ( Wo FlV ) der ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6057574) + 'px', 
														top: _vm.gib_hoehe_in_mm(73.4325638) + 'px'})},[_vm._v(" Wohnungen ............. 04 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(82.3851479) + 'px'})},[_vm._v(" Anzahl der ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(85.9121479) + 'px'})},[_vm._v(" Wohnungen mit ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(89.9660817) + 'px'})},[_vm._v(" (Räume, ein ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(93.4930817) + 'px'})},[_vm._v(" schließl. Küchen) ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(143.439563) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.331544) + 'px'})},[_vm._v(" neuer Zustand ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.372359) + 'px', 
														top: _vm.gib_hoehe_in_mm(48.717464) + 'px'})},[_vm._v(" in vollen qm ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(173.5121758) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.331544) + 'px'})},[_vm._v(" alter Zustand ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.5646326) + 'px', 
														top: _vm.gib_hoehe_in_mm(48.717464) + 'px'})},[_vm._v(" in vollen qm ")]),(_vm.formular.nutzneu)?_c('b-popover',{ref:"nutzneu",attrs:{"show":_vm.formular.nutzneu.showPop==true,"target":"nutzneu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.nutzneu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.nutzneu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("nutzneu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("nutzneu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.nutzneu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.nutzneu.text),expression:"formular.nutzneu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(24.4944382) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(142.1500275) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(59.5041002) + 'px', 
		
														'font-size': _vm.formular.nutzneu.size + 'px', 
														'text-align': _vm.formular.nutzneu.schriftausrichtung, 
														'letter-spacing': _vm.formular.nutzneu.letterSpacing + 'px',
														'font-weight': _vm.formular.nutzneu.schriftart }),attrs:{"id":"nutzneu","type":"text","disabled":_vm.formular.nutzneu.isDisabled==true || _vm.formular.nutzneu.isDisabled==true},domProps:{"value":(_vm.formular.nutzneu.text)},on:{"focus":function($event){_vm.formular.nutzneu.showPop=true},"blur":function($event){_vm.formular.nutzneu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.nutzneu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.nutzneu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.nutzalt)?_c('b-popover',{ref:"nutzalt",attrs:{"show":_vm.formular.nutzalt.showPop==true,"target":"nutzalt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.nutzalt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.nutzalt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("nutzalt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("nutzalt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.nutzalt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.nutzalt.text),expression:"formular.nutzalt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(24.9945668) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(171.8512472) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(59.5041002) + 'px', 
		
														'font-size': _vm.formular.nutzalt.size + 'px', 
														'text-align': _vm.formular.nutzalt.schriftausrichtung, 
														'letter-spacing': _vm.formular.nutzalt.letterSpacing + 'px',
														'font-weight': _vm.formular.nutzalt.schriftart }),attrs:{"id":"nutzalt","type":"text","disabled":_vm.formular.nutzalt.isDisabled==true || _vm.formular.nutzalt.isDisabled==true},domProps:{"value":(_vm.formular.nutzalt.text)},on:{"focus":function($event){_vm.formular.nutzalt.showPop=true},"blur":function($event){_vm.formular.nutzalt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.nutzalt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.nutzalt, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.wohnneu)?_c('b-popover',{ref:"wohnneu",attrs:{"show":_vm.formular.wohnneu.showPop==true,"target":"wohnneu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.wohnneu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.wohnneu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("wohnneu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("wohnneu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.wohnneu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.wohnneu.text),expression:"formular.wohnneu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(24.668672) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(142.1708368) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(72.6111376) + 'px', 
		
														'font-size': _vm.formular.wohnneu.size + 'px', 
														'text-align': _vm.formular.wohnneu.schriftausrichtung, 
														'letter-spacing': _vm.formular.wohnneu.letterSpacing + 'px',
														'font-weight': _vm.formular.wohnneu.schriftart }),attrs:{"id":"wohnneu","type":"text","disabled":_vm.formular.wohnneu.isDisabled==true || _vm.formular.wohnneu.isDisabled==true},domProps:{"value":(_vm.formular.wohnneu.text)},on:{"focus":function($event){_vm.formular.wohnneu.showPop=true},"blur":function($event){_vm.formular.wohnneu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.wohnneu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.wohnneu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.wohnalt)?_c('b-popover',{ref:"wohnalt",attrs:{"show":_vm.formular.wohnalt.showPop==true,"target":"wohnalt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.wohnalt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.wohnalt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("wohnalt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("wohnalt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.wohnalt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.wohnalt.text),expression:"formular.wohnalt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(24.9815169) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(171.8642971) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(72.6111376) + 'px', 
		
														'font-size': _vm.formular.wohnalt.size + 'px', 
														'text-align': _vm.formular.wohnalt.schriftausrichtung, 
														'letter-spacing': _vm.formular.wohnalt.letterSpacing + 'px',
														'font-weight': _vm.formular.wohnalt.schriftart }),attrs:{"id":"wohnalt","type":"text","disabled":_vm.formular.wohnalt.isDisabled==true || _vm.formular.wohnalt.isDisabled==true},domProps:{"value":(_vm.formular.wohnalt.text)},on:{"focus":function($event){_vm.formular.wohnalt.showPop=true},"blur":function($event){_vm.formular.wohnalt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.wohnalt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.wohnalt, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(143.4377995) + 'px', 
														top: _vm.gib_hoehe_in_mm(91.7295817) + 'px'})},[_vm._v(" neuer Zustand ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(173.5104123) + 'px', 
														top: _vm.gib_hoehe_in_mm(91.7295817) + 'px'})},[_vm._v(" alter Zustand ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9926346) + 'px', 
														top: _vm.gib_hoehe_in_mm(63.3076049) + 'px'})},[_vm._v(" Bei allen ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9926346) + 'px', 
														top: _vm.gib_hoehe_in_mm(65.6643463) + 'px'})},[_vm._v(" Baumaß ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9926346) + 'px', 
														top: _vm.gib_hoehe_in_mm(68.020735) + 'px'})},[_vm._v(" nahmen ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9700618) + 'px', 
														top: _vm.gib_hoehe_in_mm(78.4557172) + 'px'})},[_vm._v(" bei ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9700618) + 'px', 
														top: _vm.gib_hoehe_in_mm(80.8124586) + 'px'})},[_vm._v(" Neubau ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9700618) + 'px', 
														top: _vm.gib_hoehe_in_mm(83.1692) + 'px'})},[_vm._v(" ist nur ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9700618) + 'px', 
														top: _vm.gib_hoehe_in_mm(85.5255887) + 'px'})},[_vm._v(" der neue ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9700618) + 'px', 
														top: _vm.gib_hoehe_in_mm(87.8823301) + 'px'})},[_vm._v(" Zustand ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9700618) + 'px', 
														top: _vm.gib_hoehe_in_mm(90.2390715) + 'px'})},[_vm._v(" auszu ")]),_c('div',{style:({
														fontSize:'8.7465px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(198.9700618) + 'px', 
														top: _vm.gib_hoehe_in_mm(92.5954602) + 'px'})},[_vm._v(" füllen ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(168.1264468) + 'px', 
														top: _vm.gib_hoehe_in_mm(60.8817343) + 'px'})},[_vm._v(" 05 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(168.1133969) + 'px', 
														top: _vm.gib_hoehe_in_mm(73.9891244) + 'px'})},[_vm._v(" 06 ")]),(_vm.formular.kosten)?_c('b-popover',{ref:"kosten",attrs:{"show":_vm.formular.kosten.showPop==true,"target":"kosten"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.kosten.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.kosten.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("kosten", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("kosten", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.kosten!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.kosten.text),expression:"formular.kosten.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(36.4918814) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(159.7899653) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(193.8069697) + 'px', 
		
														'font-size': _vm.formular.kosten.size + 'px', 
														'text-align': _vm.formular.kosten.schriftausrichtung, 
														'letter-spacing': _vm.formular.kosten.letterSpacing + 'px',
														'font-weight': _vm.formular.kosten.schriftart }),attrs:{"id":"kosten","type":"text","disabled":_vm.formular.kosten.isDisabled==true || _vm.formular.kosten.isDisabled==true},domProps:{"value":(_vm.formular.kosten.text)},on:{"focus":function($event){_vm.formular.kosten.showPop=true},"blur":function($event){_vm.formular.kosten.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.kosten.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.kosten, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.strassenschluessel)?_c('b-popover',{ref:"strassenschluessel",attrs:{"show":_vm.formular.strassenschluessel.showPop==true,"target":"strassenschluessel"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.strassenschluessel.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.strassenschluessel.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("strassenschluessel", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("strassenschluessel", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.strassenschluessel!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.strassenschluessel.text),expression:"formular.strassenschluessel.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(72.4838583) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(123.7979884) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(208.2507401) + 'px', 
		
														'font-size': _vm.formular.strassenschluessel.size + 'px', 
														'text-align': _vm.formular.strassenschluessel.schriftausrichtung, 
														'letter-spacing': _vm.formular.strassenschluessel.letterSpacing + 'px',
														'font-weight': _vm.formular.strassenschluessel.schriftart }),attrs:{"id":"strassenschluessel","type":"text","disabled":_vm.formular.strassenschluessel.isDisabled==true || _vm.formular.strassenschluessel.isDisabled==true},domProps:{"value":(_vm.formular.strassenschluessel.text)},on:{"focus":function($event){_vm.formular.strassenschluessel.showPop=true},"blur":function($event){_vm.formular.strassenschluessel.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.strassenschluessel.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.strassenschluessel, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.6418739) + 'px', 
														top: _vm.gib_hoehe_in_mm(102.0478202) + 'px'})},[_vm._v(" 15 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.6214173) + 'px', 
														top: _vm.gib_hoehe_in_mm(109.5462222) + 'px'})},[_vm._v(" 16 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.6789074) + 'px', 
														top: _vm.gib_hoehe_in_mm(117.0446242) + 'px'})},[_vm._v(" 17 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.6337618) + 'px', 
														top: _vm.gib_hoehe_in_mm(124.5430262) + 'px'})},[_vm._v(" 18 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.6312929) + 'px', 
														top: _vm.gib_hoehe_in_mm(132.0410755) + 'px'})},[_vm._v(" 19 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.5579313) + 'px', 
														top: _vm.gib_hoehe_in_mm(139.5394775) + 'px'})},[_vm._v(" 20 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.6129525) + 'px', 
														top: _vm.gib_hoehe_in_mm(149.1198676) + 'px'})},[_vm._v(" 21 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(174.5378274) + 'px', 
														top: _vm.gib_hoehe_in_mm(165.7542577) + 'px'})},[_vm._v(" 22 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.4033966) + 'px', 
														top: _vm.gib_hoehe_in_mm(102.0478202) + 'px'})},[_vm._v(" 07 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.3392052) + 'px', 
														top: _vm.gib_hoehe_in_mm(109.5462222) + 'px'})},[_vm._v(" 08 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.3356782) + 'px', 
														top: _vm.gib_hoehe_in_mm(117.0446242) + 'px'})},[_vm._v(" 09 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.428791) + 'px', 
														top: _vm.gib_hoehe_in_mm(124.5430262) + 'px'})},[_vm._v(" 10 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.5434185) + 'px', 
														top: _vm.gib_hoehe_in_mm(132.0410755) + 'px'})},[_vm._v(" 11 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.4584178) + 'px', 
														top: _vm.gib_hoehe_in_mm(139.5394775) + 'px'})},[_vm._v(" 12 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.460534) + 'px', 
														top: _vm.gib_hoehe_in_mm(149.1198676) + 'px'})},[_vm._v(" 13 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(145.4520692) + 'px', 
														top: _vm.gib_hoehe_in_mm(165.7542577) + 'px'})},[_vm._v(" 14 ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(123.9864656) + 'px'})},[_vm._v(" 4 Räumen ................. ")]),(_vm.formular.raum4neu)?_c('b-popover',{ref:"raum4neu",attrs:{"show":_vm.formular.raum4neu.showPop==true,"target":"raum4neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum4neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum4neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum4neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum4neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum4neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum4neu.text),expression:"formular.raum4neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(123.164334) + 'px', 
		
														'font-size': _vm.formular.raum4neu.size + 'px', 
														'text-align': _vm.formular.raum4neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum4neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum4neu.schriftart }),attrs:{"id":"raum4neu","type":"text","disabled":_vm.formular.raum4neu.isDisabled==true || _vm.formular.raum4neu.isDisabled==true},domProps:{"value":(_vm.formular.raum4neu.text)},on:{"focus":function($event){_vm.formular.raum4neu.showPop=true},"blur":function($event){_vm.formular.raum4neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum4neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum4neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum4alt)?_c('b-popover',{ref:"raum4alt",attrs:{"show":_vm.formular.raum4alt.showPop==true,"target":"raum4alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum4alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum4alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum4alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum4alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum4alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum4alt.text),expression:"formular.raum4alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(123.164334) + 'px', 
		
														'font-size': _vm.formular.raum4alt.size + 'px', 
														'text-align': _vm.formular.raum4alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum4alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum4alt.schriftart }),attrs:{"id":"raum4alt","type":"text","disabled":_vm.formular.raum4alt.isDisabled==true || _vm.formular.raum4alt.isDisabled==true},domProps:{"value":(_vm.formular.raum4alt.text)},on:{"focus":function($event){_vm.formular.raum4alt.showPop=true},"blur":function($event){_vm.formular.raum4alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum4alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum4alt, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(138.9829169) + 'px'})},[_vm._v(" 6 Räumen ................. ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(145.036307) + 'px'})},[_vm._v(" 7 Räumen ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(112.3070867) + 'px', 
														top: _vm.gib_hoehe_in_mm(148.563307) + 'px'})},[_vm._v(" oder mehr .............. ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(154.6166971) + 'px'})},[_vm._v(" Anzahl der Räume ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(158.1436971) + 'px'})},[_vm._v(" in Wohnungen ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(161.6706971) + 'px'})},[_vm._v(" mit 7 oder mehr ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(165.1976971) + 'px'})},[_vm._v(" Räumen ..................... ")]),(_vm.formular.raum5neu)?_c('b-popover',{ref:"raum5neu",attrs:{"show":_vm.formular.raum5neu.showPop==true,"target":"raum5neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum5neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum5neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum5neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum5neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum5neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum5neu.text),expression:"formular.raum5neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(130.662736) + 'px', 
		
														'font-size': _vm.formular.raum5neu.size + 'px', 
														'text-align': _vm.formular.raum5neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum5neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum5neu.schriftart }),attrs:{"id":"raum5neu","type":"text","disabled":_vm.formular.raum5neu.isDisabled==true || _vm.formular.raum5neu.isDisabled==true},domProps:{"value":(_vm.formular.raum5neu.text)},on:{"focus":function($event){_vm.formular.raum5neu.showPop=true},"blur":function($event){_vm.formular.raum5neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum5neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum5neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum5alt)?_c('b-popover',{ref:"raum5alt",attrs:{"show":_vm.formular.raum5alt.showPop==true,"target":"raum5alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum5alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum5alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum5alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum5alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum5alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum5alt.text),expression:"formular.raum5alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(130.662736) + 'px', 
		
														'font-size': _vm.formular.raum5alt.size + 'px', 
														'text-align': _vm.formular.raum5alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum5alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum5alt.schriftart }),attrs:{"id":"raum5alt","type":"text","disabled":_vm.formular.raum5alt.isDisabled==true || _vm.formular.raum5alt.isDisabled==true},domProps:{"value":(_vm.formular.raum5alt.text)},on:{"focus":function($event){_vm.formular.raum5alt.showPop=true},"blur":function($event){_vm.formular.raum5alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum5alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum5alt, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum6neu)?_c('b-popover',{ref:"raum6neu",attrs:{"show":_vm.formular.raum6neu.showPop==true,"target":"raum6neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum6neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum6neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum6neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum6neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum6neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum6neu.text),expression:"formular.raum6neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(138.161138) + 'px', 
		
														'font-size': _vm.formular.raum6neu.size + 'px', 
														'text-align': _vm.formular.raum6neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum6neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum6neu.schriftart }),attrs:{"id":"raum6neu","type":"text","disabled":_vm.formular.raum6neu.isDisabled==true || _vm.formular.raum6neu.isDisabled==true},domProps:{"value":(_vm.formular.raum6neu.text)},on:{"focus":function($event){_vm.formular.raum6neu.showPop=true},"blur":function($event){_vm.formular.raum6neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum6neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum6neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum6alt)?_c('b-popover',{ref:"raum6alt",attrs:{"show":_vm.formular.raum6alt.showPop==true,"target":"raum6alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum6alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum6alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum6alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum6alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum6alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum6alt.text),expression:"formular.raum6alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(138.161138) + 'px', 
		
														'font-size': _vm.formular.raum6alt.size + 'px', 
														'text-align': _vm.formular.raum6alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum6alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum6alt.schriftart }),attrs:{"id":"raum6alt","type":"text","disabled":_vm.formular.raum6alt.isDisabled==true || _vm.formular.raum6alt.isDisabled==true},domProps:{"value":(_vm.formular.raum6alt.text)},on:{"focus":function($event){_vm.formular.raum6alt.showPop=true},"blur":function($event){_vm.formular.raum6alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum6alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum6alt, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum7neu)?_c('b-popover',{ref:"raum7neu",attrs:{"show":_vm.formular.raum7neu.showPop==true,"target":"raum7neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum7neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum7neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum7neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum7neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum7neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum7neu.text),expression:"formular.raum7neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(147.6889758) + 'px', 
		
														'font-size': _vm.formular.raum7neu.size + 'px', 
														'text-align': _vm.formular.raum7neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum7neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum7neu.schriftart }),attrs:{"id":"raum7neu","type":"text","disabled":_vm.formular.raum7neu.isDisabled==true || _vm.formular.raum7neu.isDisabled==true},domProps:{"value":(_vm.formular.raum7neu.text)},on:{"focus":function($event){_vm.formular.raum7neu.showPop=true},"blur":function($event){_vm.formular.raum7neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum7neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum7neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum7alt)?_c('b-popover',{ref:"raum7alt",attrs:{"show":_vm.formular.raum7alt.showPop==true,"target":"raum7alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum7alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum7alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum7alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum7alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum7alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum7alt.text),expression:"formular.raum7alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(147.6889758) + 'px', 
		
														'font-size': _vm.formular.raum7alt.size + 'px', 
														'text-align': _vm.formular.raum7alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum7alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum7alt.schriftart }),attrs:{"id":"raum7alt","type":"text","disabled":_vm.formular.raum7alt.isDisabled==true || _vm.formular.raum7alt.isDisabled==true},domProps:{"value":(_vm.formular.raum7alt.text)},on:{"focus":function($event){_vm.formular.raum7alt.showPop=true},"blur":function($event){_vm.formular.raum7alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum7alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum7alt, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum8neu)?_c('b-popover',{ref:"raum8neu",attrs:{"show":_vm.formular.raum8neu.showPop==true,"target":"raum8neu"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum8neu.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum8neu.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum8neu", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum8neu", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum8neu!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum8neu.text),expression:"formular.raum8neu.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.4973477) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(149.0703542) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(164.3233659) + 'px', 
		
														'font-size': _vm.formular.raum8neu.size + 'px', 
														'text-align': _vm.formular.raum8neu.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum8neu.letterSpacing + 'px',
														'font-weight': _vm.formular.raum8neu.schriftart }),attrs:{"id":"raum8neu","type":"text","disabled":_vm.formular.raum8neu.isDisabled==true || _vm.formular.raum8neu.isDisabled==true},domProps:{"value":(_vm.formular.raum8neu.text)},on:{"focus":function($event){_vm.formular.raum8neu.showPop=true},"blur":function($event){_vm.formular.raum8neu.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum8neu.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum8neu, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.raum8alt)?_c('b-popover',{ref:"raum8alt",attrs:{"show":_vm.formular.raum8alt.showPop==true,"target":"raum8alt"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.raum8alt.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.raum8alt.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum8alt", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("raum8alt", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.raum8alt!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.raum8alt.text),expression:"formular.raum8alt.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(12.496995) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(178.2640386) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(164.3233659) + 'px', 
		
														'font-size': _vm.formular.raum8alt.size + 'px', 
														'text-align': _vm.formular.raum8alt.schriftausrichtung, 
														'letter-spacing': _vm.formular.raum8alt.letterSpacing + 'px',
														'font-weight': _vm.formular.raum8alt.schriftart }),attrs:{"id":"raum8alt","type":"text","disabled":_vm.formular.raum8alt.isDisabled==true || _vm.formular.raum8alt.isDisabled==true},domProps:{"value":(_vm.formular.raum8alt.text)},on:{"focus":function($event){_vm.formular.raum8alt.showPop=true},"blur":function($event){_vm.formular.raum8alt.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.raum8alt.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.raum8alt, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.6047286) + 'px', 
														top: _vm.gib_hoehe_in_mm(180.2586925) + 'px'})},[_vm._v(" 5 Veranschlagte Kosten des Bauwerks 5 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(185.0476531) + 'px'})},[_vm._v(" bzw. der Baumaßnahme (Kostengruppe 300, 400 DIN 276) ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6039939) + 'px', 
														top: _vm.gib_hoehe_in_mm(191.0999851) + 'px'})},[_vm._v(" Kosten in 1 000 Euro ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(109.6011723) + 'px', 
														top: _vm.gib_hoehe_in_mm(194.6269851) + 'px'})},[_vm._v(" (einschließlich MwSt) ................... 23 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(120.1232714) + 'px', 
														top: _vm.gib_hoehe_in_mm(209.5976893) + 'px'})},[_vm._v(" 24 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(123.4947307) + 'px', 
														top: _vm.gib_hoehe_in_mm(212.2217773) + 'px'})},[_vm._v(" Straßenschlüssel ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(40.0572682) + 'px'})},[_vm._v(" Keine .......... 00 ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.5562139) + 'px'})},[_vm._v(" Öl ............... ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(51.0548069) + 'px'})},[_vm._v(" Gas ......... ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(37.7438378) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.8334361) + 'px'})},[_vm._v(" 02 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(37.7417216) + 'px', 
														top: _vm.gib_hoehe_in_mm(51.3323818) + 'px'})},[_vm._v(" 03 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(56.5537526) + 'px'})},[_vm._v(" Strom ................04 ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(62.1951891) + 'px'})},[_vm._v(" Fernwärme/ ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(65.6340141) + 'px'})},[_vm._v(" Fernkälte .......05 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(71.1319017) + 'px'})},[_vm._v(" Geothermie ......06 ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(76.7743963) + 'px'})},[_vm._v(" Umweltthermie ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(80.3013963) + 'px'})},[_vm._v(" (Luft/Wasser) ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(37.7156218) + 'px', 
														top: _vm.gib_hoehe_in_mm(80.4907962) + 'px'})},[_vm._v(" 07 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(85.7114616) + 'px'})},[_vm._v(" Solarthermie ....08 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(91.2111127) + 'px'})},[_vm._v(" Holz ..................09 ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(96.8529019) + 'px'})},[_vm._v(" Biogas/ ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(100.2917269) + 'px'})},[_vm._v(" Biomethan ....... 10 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7209633) + 'px', 
														top: _vm.gib_hoehe_in_mm(105.8784949) + 'px'})},[_vm._v(" Sonst. Biomasse 11 ")]),_c('div',{style:({
														fontSize:'10.497px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(18.7199052) + 'px', 
														top: _vm.gib_hoehe_in_mm(111.3774406) + 'px'})},[_vm._v(" Sonst. Energie ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(37.7903942) + 'px', 
														top: _vm.gib_hoehe_in_mm(111.2882075) + 'px'})},[_vm._v(" ..12 ")]),(_vm.formular.hzg2!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.220049) + 'px',top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg2.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg2, "text", $$v)},expression:"formular.hzg2.text"}}):_vm._e(),(_vm.formular.hzg14!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3725185) + 'px',top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg14.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg14, "text", $$v)},expression:"formular.hzg14.text"}}):_vm._e(),(_vm.formular.hzg26!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1616929) + 'px',top: _vm.gib_hoehe_in_mm(44.4396421) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg26.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg26, "text", $$v)},expression:"formular.hzg26.text"}}):_vm._e(),(_vm.formular.hzg38!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.659103) + 'px',top: _vm.gib_hoehe_in_mm(44.4396421) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg38.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg38, "text", $$v)},expression:"formular.hzg38.text"}}):_vm._e(),(_vm.formular.hzg3!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.220049) + 'px',top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg3.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg3, "text", $$v)},expression:"formular.hzg3.text"}}):_vm._e(),(_vm.formular.hzg15!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3725185) + 'px',top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg15.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg15, "text", $$v)},expression:"formular.hzg15.text"}}):_vm._e(),(_vm.formular.hzg27!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1616929) + 'px',top: _vm.gib_hoehe_in_mm(49.9382351) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg27.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg27, "text", $$v)},expression:"formular.hzg27.text"}}):_vm._e(),(_vm.formular.hzg39!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.659103) + 'px',top: _vm.gib_hoehe_in_mm(49.9382351) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg39.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg39, "text", $$v)},expression:"formular.hzg39.text"}}):_vm._e(),(_vm.formular.hzg4!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.220049) + 'px',top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg4.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg4, "text", $$v)},expression:"formular.hzg4.text"}}):_vm._e(),(_vm.formular.hzg16!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3725185) + 'px',top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg16.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg16, "text", $$v)},expression:"formular.hzg16.text"}}):_vm._e(),(_vm.formular.hzg28!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1616929) + 'px',top: _vm.gib_hoehe_in_mm(55.4371808) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg28.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg28, "text", $$v)},expression:"formular.hzg28.text"}}):_vm._e(),(_vm.formular.hzg40!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.659103) + 'px',top: _vm.gib_hoehe_in_mm(55.4371808) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg40.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg40, "text", $$v)},expression:"formular.hzg40.text"}}):_vm._e(),(_vm.formular.hzg5!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.220049) + 'px',top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg5.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg5, "text", $$v)},expression:"formular.hzg5.text"}}):_vm._e(),(_vm.formular.hzg17!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3725185) + 'px',top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg17.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg17, "text", $$v)},expression:"formular.hzg17.text"}}):_vm._e(),(_vm.formular.hzg29!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1616929) + 'px',top: _vm.gib_hoehe_in_mm(64.5174423) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg29.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg29, "text", $$v)},expression:"formular.hzg29.text"}}):_vm._e(),(_vm.formular.hzg41!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.659103) + 'px',top: _vm.gib_hoehe_in_mm(64.5174423) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg41.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg41, "text", $$v)},expression:"formular.hzg41.text"}}):_vm._e(),(_vm.formular.hzg6!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.2239287) + 'px',top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg6.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg6, "text", $$v)},expression:"formular.hzg6.text"}}):_vm._e(),(_vm.formular.hzg18!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3763982) + 'px',top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg18.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg18, "text", $$v)},expression:"formular.hzg18.text"}}):_vm._e(),(_vm.formular.hzg30!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1655726) + 'px',top: _vm.gib_hoehe_in_mm(70.0167407) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg30.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg30, "text", $$v)},expression:"formular.hzg30.text"}}):_vm._e(),(_vm.formular.hzg42!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.6629827) + 'px',top: _vm.gib_hoehe_in_mm(70.0167407) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg42.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg42, "text", $$v)},expression:"formular.hzg42.text"}}):_vm._e(),(_vm.formular.hzg7!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.1749034) + 'px',top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg7.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg7, "text", $$v)},expression:"formular.hzg7.text"}}):_vm._e(),(_vm.formular.hzg19!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3273729) + 'px',top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg19.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg19, "text", $$v)},expression:"formular.hzg19.text"}}):_vm._e(),(_vm.formular.hzg31!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1165473) + 'px',top: _vm.gib_hoehe_in_mm(79.0966495) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg31.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg31, "text", $$v)},expression:"formular.hzg31.text"}}):_vm._e(),(_vm.formular.hzg43!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.6139574) + 'px',top: _vm.gib_hoehe_in_mm(79.0966495) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg43.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg43, "text", $$v)},expression:"formular.hzg43.text"}}):_vm._e(),(_vm.formular.hzg8!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.1749034) + 'px',top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg8.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg8, "text", $$v)},expression:"formular.hzg8.text"}}):_vm._e(),(_vm.formular.hzg20!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.3273729) + 'px',top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg20.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg20, "text", $$v)},expression:"formular.hzg20.text"}}):_vm._e(),(_vm.formular.hzg32!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.1165473) + 'px',top: _vm.gib_hoehe_in_mm(84.5959479) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg32.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg32, "text", $$v)},expression:"formular.hzg32.text"}}):_vm._e(),(_vm.formular.hzg44!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.6139574) + 'px',top: _vm.gib_hoehe_in_mm(84.5959479) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg44.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg44, "text", $$v)},expression:"formular.hzg44.text"}}):_vm._e(),(_vm.formular.hzg9!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(41.0803798) + 'px',top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg9.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg9, "text", $$v)},expression:"formular.hzg9.text"}}):_vm._e(),(_vm.formular.hzg21!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(51.2328493) + 'px',top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg21.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg21, "text", $$v)},expression:"formular.hzg21.text"}}):_vm._e(),(_vm.formular.hzg33!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(87.0220237) + 'px',top: _vm.gib_hoehe_in_mm(90.0945409) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg33.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg33, "text", $$v)},expression:"formular.hzg33.text"}}):_vm._e(),(_vm.formular.hzg45!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.5194338) + 'px',top: _vm.gib_hoehe_in_mm(90.0945409) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.hzg45.text),callback:function ($$v) {_vm.$set(_vm.formular.hzg45, "text", $$v)},expression:"formular.hzg45.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(39.3606857) + 'px'})},[_vm._v(" Keine ................ 00 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(44.8596314) + 'px'})},[_vm._v(" Öl ...................... 02 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(50.4735573) + 'px'})},[_vm._v(" Gas ................... 03 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(55.972503) + 'px'})},[_vm._v(" Strom ................ 04 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(61.5257645) + 'px'})},[_vm._v(" Fernwärme/ ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(65.0527645) + 'px'})},[_vm._v(" Fernkälte .......... 05 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(70.5517102) + 'px'})},[_vm._v(" Geothermie ...... 06 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(76.1049717) + 'px'})},[_vm._v(" Umweltthermie ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(79.6319717) + 'px'})},[_vm._v(" (Luft/Wasser) .. 07 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(85.1312701) + 'px'})},[_vm._v(" Solarthermie .... 08 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(90.6302158) + 'px'})},[_vm._v(" Holz .................. 09 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(96.1834773) + 'px'})},[_vm._v(" Biogas/ ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6144783) + 'px', 
														top: _vm.gib_hoehe_in_mm(99.7104773) + 'px'})},[_vm._v(" Biomethan ....... 10 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(62.6151837) + 'px', 
														top: _vm.gib_hoehe_in_mm(105.209423) + 'px'})},[_vm._v(" Sonst. Biomasse11 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.8751453) + 'px', 
														top: _vm.gib_hoehe_in_mm(40.3344904) + 'px'})},[_vm._v(" 00 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9439218) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.8334361) + 'px'})},[_vm._v(" 13 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9396894) + 'px', 
														top: _vm.gib_hoehe_in_mm(51.3323818) + 'px'})},[_vm._v(" 14 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9379259) + 'px', 
														top: _vm.gib_hoehe_in_mm(56.8309748) + 'px'})},[_vm._v(" 15 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9276976) + 'px', 
														top: _vm.gib_hoehe_in_mm(65.911589) + 'px'})},[_vm._v(" 16 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9562663) + 'px', 
														top: _vm.gib_hoehe_in_mm(71.410182) + 'px'})},[_vm._v(" 17 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9336935) + 'px', 
														top: _vm.gib_hoehe_in_mm(80.4907962) + 'px'})},[_vm._v(" 18 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9326354) + 'px', 
														top: _vm.gib_hoehe_in_mm(85.9897419) + 'px'})},[_vm._v(" 19 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.8959546) + 'px', 
														top: _vm.gib_hoehe_in_mm(91.4886876) + 'px'})},[_vm._v(" 20 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.9234652) + 'px', 
														top: _vm.gib_hoehe_in_mm(100.5689491) + 'px'})},[_vm._v(" 21 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.8857263) + 'px', 
														top: _vm.gib_hoehe_in_mm(106.0678948) + 'px'})},[_vm._v(" 22 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(47.8959546) + 'px', 
														top: _vm.gib_hoehe_in_mm(111.5664878) + 'px'})},[_vm._v(" 23 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(147.2643129) + 'px'})},[_vm._v(" Einsatz von Lüftungs und Kühlungsanlagen ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(152.3177985) + 'px'})},[_vm._v(" Anlagen zur Lüftung ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(61.7775212) + 'px', 
														top: _vm.gib_hoehe_in_mm(152.3177985) + 'px'})},[_vm._v(" Anlagen zur Kühlung ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(156.8718609) + 'px'})},[_vm._v(" mit Wärmerück ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(160.3988609) + 'px'})},[_vm._v(" gewinnung ...................... 1 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8473254) + 'px', 
														top: _vm.gib_hoehe_in_mm(165.4519938) + 'px'})},[_vm._v(" ohne Wärmerück ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8473254) + 'px', 
														top: _vm.gib_hoehe_in_mm(168.9789938) + 'px'})},[_vm._v(" gewinnung ...................... 2 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8473254) + 'px', 
														top: _vm.gib_hoehe_in_mm(174.9777154) + 'px'})},[_vm._v(" keine Nutzung ............... 3 ")]),(_vm.formular.lftg1!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(53.8932654) + 'px',top: _vm.gib_hoehe_in_mm(159.9785189) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.lftg1.text),callback:function ($$v) {_vm.$set(_vm.formular.lftg1, "text", $$v)},expression:"formular.lftg1.text"}}):_vm._e(),(_vm.formular.lftg2!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(53.8932654) + 'px',top: _vm.gib_hoehe_in_mm(168.5586518) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.lftg2.text),callback:function ($$v) {_vm.$set(_vm.formular.lftg2, "text", $$v)},expression:"formular.lftg2.text"}}):_vm._e(),(_vm.formular.lftg3!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(53.8932654) + 'px',top: _vm.gib_hoehe_in_mm(174.5580788) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.lftg3.text),callback:function ($$v) {_vm.$set(_vm.formular.lftg3, "text", $$v)},expression:"formular.lftg3.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(61.7746996) + 'px', 
														top: _vm.gib_hoehe_in_mm(158.8159433) + 'px'})},[_vm._v(" elektrisch ....................... ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(95.5940445) + 'px', 
														top: _vm.gib_hoehe_in_mm(159.3728566) + 'px'})},[_vm._v(" 1 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(61.7775212) + 'px', 
														top: _vm.gib_hoehe_in_mm(165.3151462) + 'px'})},[_vm._v(" thermisch ....................... 2 ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(61.7775212) + 'px', 
														top: _vm.gib_hoehe_in_mm(171.8136437) + 'px'})},[_vm._v(" keine Nutzung .............. ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(95.5940445) + 'px', 
														top: _vm.gib_hoehe_in_mm(172.3702043) + 'px'})},[_vm._v(" 3 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(182.5307859) + 'px'})},[_vm._v(" Art der Erfüllung des EEWärmeG ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(186.5854251) + 'px'})},[_vm._v(" Mehrfachnennungen möglich. ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(191.6389107) + 'px'})},[_vm._v(" Erneuerbare Energie (Wärme, 5) ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(21.8487069) + 'px', 
														top: _vm.gib_hoehe_in_mm(196.6387859) + 'px'})},[_vm._v(" Holz, Bioöl, Biogas, Biomethan .................................. ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(21.8487069) + 'px', 
														top: _vm.gib_hoehe_in_mm(202.1356154) + 'px'})},[_vm._v(" Sonstige (z. B. Umwelt, Geo, Solarthermie) ............ ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(207.6345611) + 'px'})},[_vm._v(" Erneuerbare Energie (Kälte, 5) ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(65.432904) + 'px', 
														top: _vm.gib_hoehe_in_mm(207.9128414) + 'px'})},[_vm._v(" ................................. ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.3116273) + 'px', 
														top: _vm.gib_hoehe_in_mm(208.1911217) + 'px'})},[_vm._v(" 03 ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(213.1331541) + 'px'})},[_vm._v(" KraftWärme/KraftWärmeKälteKopplung (7) .... ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(218.6320998) + 'px'})},[_vm._v(" Wärmerückgewinnung ( 7) .......................................... ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(224.1306928) + 'px'})},[_vm._v(" Sonstige Abwärme ( 7) ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(54.7104713) + 'px', 
														top: _vm.gib_hoehe_in_mm(224.4089731) + 'px'})},[_vm._v(" ............................................... ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2693033) + 'px', 
														top: _vm.gib_hoehe_in_mm(224.6872534) + 'px'})},[_vm._v(" 06 ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(229.6296385) + 'px'})},[_vm._v(" Energieeinsparung (Übererfüllung EnEV, 7) .............. ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(235.1285842) + 'px'})},[_vm._v(" Fernwärme oder Fernkälte ( 7) .................................. ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8476781) + 'px', 
														top: _vm.gib_hoehe_in_mm(240.6818457) + 'px'})},[_vm._v(" Gemeinschaftliche Wärmeversorgung ( 6) ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8448565) + 'px', 
														top: _vm.gib_hoehe_in_mm(244.2088457) + 'px'})},[_vm._v(" z. B. Quartierslösung ......................................................... ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8473254) + 'px', 
														top: _vm.gib_hoehe_in_mm(249.7081441) + 'px'})},[_vm._v(" Ausnahme(regelung) ( 9) ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(57.7740235) + 'px', 
														top: _vm.gib_hoehe_in_mm(249.9864244) + 'px'})},[_vm._v(" ........................................... ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8473254) + 'px', 
														top: _vm.gib_hoehe_in_mm(255.2067371) + 'px'})},[_vm._v(" Befreiung ( 9) ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(41.6901981) + 'px', 
														top: _vm.gib_hoehe_in_mm(255.4850174) + 'px'})},[_vm._v(" ................................................................ ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(17.8473254) + 'px', 
														top: _vm.gib_hoehe_in_mm(260.7056828) + 'px'})},[_vm._v(" Sonstiges .......................................................................... ")]),(_vm.formular.lftg4!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.8234612) + 'px',top: _vm.gib_hoehe_in_mm(158.3966594) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.lftg4.text),callback:function ($$v) {_vm.$set(_vm.formular.lftg4, "text", $$v)},expression:"formular.lftg4.text"}}):_vm._e(),(_vm.formular.lftg5!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.8234612) + 'px',top: _vm.gib_hoehe_in_mm(164.8951569) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.lftg5.text),callback:function ($$v) {_vm.$set(_vm.formular.lftg5, "text", $$v)},expression:"formular.lftg5.text"}}):_vm._e(),(_vm.formular.lftg6!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.8234612) + 'px',top: _vm.gib_hoehe_in_mm(171.3940071) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.lftg6.text),callback:function ($$v) {_vm.$set(_vm.formular.lftg6, "text", $$v)},expression:"formular.lftg6.text"}}):_vm._e(),(_vm.formular.eeg1!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(196.2173858) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg1.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg1, "text", $$v)},expression:"formular.eeg1.text"}}):_vm._e(),(_vm.formular.eeg2!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(201.7152734) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg2.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg2, "text", $$v)},expression:"formular.eeg2.text"}}):_vm._e(),(_vm.formular.eeg3!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(207.2149245) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg3.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg3, "text", $$v)},expression:"formular.eeg3.text"}}):_vm._e(),(_vm.formular.eeg4!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(212.7128121) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg4.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg4, "text", $$v)},expression:"formular.eeg4.text"}}):_vm._e(),(_vm.formular.eeg5!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(218.2124632) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg5.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg5, "text", $$v)},expression:"formular.eeg5.text"}}):_vm._e(),(_vm.formular.eeg6!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(223.7103508) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg6.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg6, "text", $$v)},expression:"formular.eeg6.text"}}):_vm._e(),(_vm.formular.eeg7!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(229.2092965) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg7.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg7, "text", $$v)},expression:"formular.eeg7.text"}}):_vm._e(),(_vm.formular.eeg8!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(234.7078895) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg8.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg8, "text", $$v)},expression:"formular.eeg8.text"}}):_vm._e(),(_vm.formular.eeg9!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(243.7888564) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg9.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg9, "text", $$v)},expression:"formular.eeg9.text"}}):_vm._e(),(_vm.formular.eeg10!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(249.2878021) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg10.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg10, "text", $$v)},expression:"formular.eeg10.text"}}):_vm._e(),(_vm.formular.eeg11!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(254.7867478) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg11.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg11, "text", $$v)},expression:"formular.eeg11.text"}}):_vm._e(),(_vm.formular.eeg12!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(97.7705562) + 'px',top: _vm.gib_hoehe_in_mm(260.2853408) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.eeg12.text),callback:function ($$v) {_vm.$set(_vm.formular.eeg12, "text", $$v)},expression:"formular.eeg12.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.1620825) + 'px', 
														top: _vm.gib_hoehe_in_mm(39.9172463) + 'px'})},[_vm._v(" 00 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.230859) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.416192) + 'px'})},[_vm._v(" 13 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2266266) + 'px', 
														top: _vm.gib_hoehe_in_mm(51.0301179) + 'px'})},[_vm._v(" 14 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2248631) + 'px', 
														top: _vm.gib_hoehe_in_mm(56.5290636) + 'px'})},[_vm._v(" 15 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2146348) + 'px', 
														top: _vm.gib_hoehe_in_mm(65.6093251) + 'px'})},[_vm._v(" 16 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2432035) + 'px', 
														top: _vm.gib_hoehe_in_mm(71.1082708) + 'px'})},[_vm._v(" 17 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2206307) + 'px', 
														top: _vm.gib_hoehe_in_mm(80.1885323) + 'px'})},[_vm._v(" 18 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2195726) + 'px', 
														top: _vm.gib_hoehe_in_mm(85.6878307) + 'px'})},[_vm._v(" 19 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.1828918) + 'px', 
														top: _vm.gib_hoehe_in_mm(91.1867764) + 'px'})},[_vm._v(" 20 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2104024) + 'px', 
														top: _vm.gib_hoehe_in_mm(100.2670379) + 'px'})},[_vm._v(" 21 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.1726635) + 'px', 
														top: _vm.gib_hoehe_in_mm(105.7659836) + 'px'})},[_vm._v(" 22 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.1828918) + 'px', 
														top: _vm.gib_hoehe_in_mm(111.2645766) + 'px'})},[_vm._v(" 23 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.3673539) + 'px', 
														top: _vm.gib_hoehe_in_mm(197.193583) + 'px'})},[_vm._v(" 01 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.3158597) + 'px', 
														top: _vm.gib_hoehe_in_mm(202.692176) + 'px'})},[_vm._v(" 02 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2760046) + 'px', 
														top: _vm.gib_hoehe_in_mm(213.6897147) + 'px'})},[_vm._v(" 04 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2957558) + 'px', 
														top: _vm.gib_hoehe_in_mm(219.1886604) + 'px'})},[_vm._v(" 05 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.3539513) + 'px', 
														top: _vm.gib_hoehe_in_mm(230.1861991) + 'px'})},[_vm._v(" 07 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2897599) + 'px', 
														top: _vm.gib_hoehe_in_mm(235.6851448) + 'px'})},[_vm._v(" 08 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.2858802) + 'px', 
														top: _vm.gib_hoehe_in_mm(244.765759) + 'px'})},[_vm._v(" 09 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.3793457) + 'px', 
														top: _vm.gib_hoehe_in_mm(250.2647047) + 'px'})},[_vm._v(" 10 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.4939732) + 'px', 
														top: _vm.gib_hoehe_in_mm(255.7632977) + 'px'})},[_vm._v(" 11 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(94.4086198) + 'px', 
														top: _vm.gib_hoehe_in_mm(261.2622434) + 'px'})},[_vm._v(" 12 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.6251168) + 'px', 
														top: _vm.gib_hoehe_in_mm(279.5536181) + 'px'})},[_vm._v(" Seite 2 ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(199.4895889) + 'px', 
														top: _vm.gib_hoehe_in_mm(279.5536181) + 'px'})},[_vm._v(" BG ")]),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.4733017) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(256.7834209) + 'px', 
													top: _vm.gib_hoehe_in_mm(18.7888292) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.6669213) + 'px', 
													top: _vm.gib_hoehe_in_mm(16.134409) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.1534856) + 'px', 
													top: _vm.gib_hoehe_in_mm(22.7013303) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(88.3815154) + 'px', 
													top: _vm.gib_hoehe_in_mm(27.7544632) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(4.1542865) + 'px', 
													top: _vm.gib_hoehe_in_mm(116.0349205) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.7041165) + 'px', 
													top: _vm.gib_hoehe_in_mm(120.089207) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.5391484) + 'px', 
													top: _vm.gib_hoehe_in_mm(128.6933235) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.7030584) + 'px', 
													top: _vm.gib_hoehe_in_mm(136.13353) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.6535187) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.7365884) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(28.8129543) + 'px', 
													top: _vm.gib_hoehe_in_mm(151.2901071) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.6535187) + 'px', 
													top: _vm.gib_hoehe_in_mm(180.0030614) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(4.1539338) + 'px', 
													top: _vm.gib_hoehe_in_mm(186.5565801) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.1531329) + 'px', 
													top: _vm.gib_hoehe_in_mm(190.6105139) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.0988171) + 'px', 
													top: _vm.gib_hoehe_in_mm(195.6636468) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.5989457) + 'px', 
													top: _vm.gib_hoehe_in_mm(200.6624639) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.598593) + 'px', 
													top: _vm.gib_hoehe_in_mm(206.1614096) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.5989457) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.6600026) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.598593) + 'px', 
													top: _vm.gib_hoehe_in_mm(217.1589483) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.5989457) + 'px', 
													top: _vm.gib_hoehe_in_mm(222.6575413) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.598593) + 'px', 
													top: _vm.gib_hoehe_in_mm(228.156487) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.5989457) + 'px', 
													top: _vm.gib_hoehe_in_mm(233.65508) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(9.1799088) + 'px', 
													top: _vm.gib_hoehe_in_mm(239.1550838) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.5989457) + 'px', 
													top: _vm.gib_hoehe_in_mm(248.2349926) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.598593) + 'px', 
													top: _vm.gib_hoehe_in_mm(253.7339383) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.5989457) + 'px', 
													top: _vm.gib_hoehe_in_mm(259.2325313) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.2161487) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(10.89262) + 'px', 
													top: _vm.gib_hoehe_in_mm(264.731477) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(15.6708137) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(275.524097) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(47.8529252) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.9923679) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3603063) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(39.6635839) + 'px', 
													width: _vm.spalte_breit_mm(9.0509874) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3074013) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(39.7161362) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.9923679) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3603063) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(48.7142186) + 'px', 
													width: _vm.spalte_breit_mm(10.5506678) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3074013) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(59.2119814) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.9923679) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3603063) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(39.6635839) + 'px', 
													width: _vm.spalte_breit_mm(9.0509874) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(37.3055792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(48.7142186) + 'px', 
													width: _vm.spalte_breit_mm(10.5506678) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(37.3055792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(42.7512672) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6133757) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(42.7512672) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.3579405) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(48.2502129) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6133757) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(48.2502129) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.7488059) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6133757) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.7488059) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.3554792) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(59.2477516) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6133757) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(59.2477516) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.8544249) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.3280131) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6133757) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.3280131) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.9346864) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.2239287) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(73.8273115) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6172554) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.2239287) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.2239287) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(73.8273115) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.4336321) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(82.9072203) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.5682301) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(82.9079257) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.5142463) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.4065187) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.5682301) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.4065187) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(85.0128393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.0803798) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(93.9051117) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.4737065) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.0803798) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.0803798) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(93.9051117) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.5121377) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.9857259) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.5682301) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.1749034) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.9857259) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4936794) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5920465) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(108.4846716) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6133757) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(108.4846716) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(105.0913449) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(113.9836173) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.6133757) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(41.220049) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(113.9836173) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.7658452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(51.3725185) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.5902906) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.6097467) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.5747711) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3603063) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.5568417) + 'px', 
													width: _vm.spalte_breit_mm(9.0509874) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3074013) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(91.6074764) + 'px', 
													width: _vm.spalte_breit_mm(10.5510205) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3074013) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.6128624) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.5747711) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3603063) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.1055919) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.5747711) + 'px', 
													top: _vm.gib_hoehe_in_mm(29.3603063) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.5568417) + 'px', 
													width: _vm.spalte_breit_mm(9.0509874) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(36.8883351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(91.6074764) + 'px', 
													width: _vm.spalte_breit_mm(10.5510205) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(36.8883351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(42.3340231) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(42.3340231) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.9406964) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(47.8326161) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.4392894) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.4392894) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.4392894) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(47.8326161) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.4392894) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.4392894) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.4392894) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.4468947) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.053568) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.053568) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.053568) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.4468947) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.053568) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.053568) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(50.053568) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(58.9458404) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.5525137) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.5525137) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.5525137) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(58.9458404) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.5525137) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.5525137) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(55.5525137) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.0261019) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.6331279) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.6331279) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.6331279) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.0261019) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.6331279) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.6331279) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(64.6331279) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(73.5250476) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.1317209) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.1317209) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.1317209) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(73.5250476) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.1317209) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.1317209) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(70.1317209) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(82.6056618) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.2123351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.2123351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.2123351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(82.6056618) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.2123351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.2123351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(79.2123351) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.1042548) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(84.7109281) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(84.7109281) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(84.7109281) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.1042548) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(84.7109281) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(84.7109281) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(84.7109281) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(93.6028478) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.2095211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.2095211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.2095211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(93.6028478) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.2095211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.2095211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(90.2095211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.6838147) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.290488) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.290488) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.290488) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.6838147) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.290488) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.290488) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.290488) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(108.1827604) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.5550196) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4943848) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.7883756) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.7883756) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.1616929) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4943848) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.7883756) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(108.1827604) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4943848) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.7883756) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.7883756) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4943848) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.7883756) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.3669643) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(113.6813534) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.760291) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.2883794) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.3669643) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.2883794) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.3669643) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.2883794) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(113.6813534) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0527824) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.2883794) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(3.3936794) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.2883794) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.659103) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.2883794) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(86.4809819) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(127.640514) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.2695974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.0986261) + 'px', 
													top: _vm.gib_hoehe_in_mm(120.6418879) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(86.4809819) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(120.6418879) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.0986261) + 'px', 
													top: _vm.gib_hoehe_in_mm(120.6418879) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(86.4809819) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(143.6837789) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.2695974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.0982734) + 'px', 
													top: _vm.gib_hoehe_in_mm(136.6855055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(86.4809819) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(136.6855055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.0982734) + 'px', 
													top: _vm.gib_hoehe_in_mm(136.6855055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(163.3714929) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(57.2865921) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(159.9785189) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(159.9785189) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(159.9785189) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(171.9526839) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(57.2865921) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4940321) + 'px', 
													top: _vm.gib_hoehe_in_mm(168.5586518) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(168.5586518) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4940321) + 'px', 
													top: _vm.gib_hoehe_in_mm(168.5586518) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(177.9514055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(57.2865921) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4943848) + 'px', 
													top: _vm.gib_hoehe_in_mm(174.5570207) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(174.5570207) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.8932654) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4943848) + 'px', 
													top: _vm.gib_hoehe_in_mm(174.5570207) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(161.7899861) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.2167879) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(158.3966594) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(158.3966594) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(158.3966594) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(168.2884836) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.2167879) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(164.8951569) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(164.8951569) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(164.8951569) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(174.7869811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.2167879) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(171.3940071) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(171.3940071) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.8234612) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(171.3940071) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(199.6107125) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.2173858) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.2173858) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.2173858) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(205.1086001) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(201.7152734) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(201.7152734) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(201.7152734) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(210.6082512) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(207.2149245) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(207.2149245) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(207.2149245) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(216.1061388) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(212.7128121) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(212.7128121) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(212.7128121) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(221.6057899) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(218.2124632) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(218.2124632) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(218.2124632) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(227.1036775) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(223.7103508) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(223.7103508) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(223.7103508) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(232.6033286) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4940321) + 'px', 
													top: _vm.gib_hoehe_in_mm(229.2092965) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(229.2092965) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4940321) + 'px', 
													top: _vm.gib_hoehe_in_mm(229.2092965) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(238.1012162) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(234.7078895) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(234.7078895) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(234.7078895) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(247.1821831) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(243.7888564) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(243.7888564) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(243.7888564) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(252.6811288) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(249.2878021) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(249.2878021) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(249.2878021) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(258.1797218) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(254.7867478) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(254.7867478) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(254.7867478) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(263.6786675) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.1638829) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(260.2853408) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(260.2853408) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(97.7705562) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.4933267) + 'px', 
													top: _vm.gib_hoehe_in_mm(260.2853408) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(86.4809819) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(275.4722501) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.2695974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.0987216) + 'px', 
													top: _vm.gib_hoehe_in_mm(269.4735285) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(86.4809819) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(269.4735285) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.7886155) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(6.0987216) + 'px', 
													top: _vm.gib_hoehe_in_mm(269.4735285) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(162.4864211) + 'px', 
													width: _vm.spalte_breit_mm(40.0970522) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(13.6122513) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(162.5393261) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(12.6656045) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(162.5393261) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(12.6656045) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(202.5305683) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(12.6656045) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1050482) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(171.2758526) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(105.6047286) + 'px', 
													width: _vm.spalte_breit_mm(90.9803758) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(171.2758526) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.5851044) + 'px', 
													width: _vm.spalte_breit_mm(2.0523613) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(171.2758526) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(198.5316557) + 'px', 
													width: _vm.spalte_breit_mm(11.0504437) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(16.134409) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(198.5845607) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(258.5910084) + 'px', 
													top: _vm.gib_hoehe_in_mm(16.187314) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(198.5316557) + 'px', 
													width: _vm.spalte_breit_mm(11.0504437) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(43.7511717) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(209.5820994) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(258.6439134) + 'px', 
													top: _vm.gib_hoehe_in_mm(16.134409) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(198.5316557) + 'px', 
													width: _vm.spalte_breit_mm(11.0504437) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(274.6783224) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.4415034) + 'px', 
													width: _vm.spalte_breit_mm(28.099609) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(33.2005039) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.4944084) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.493321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(175.4925863) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(179.4918516) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.4907642) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.4900295) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(191.4889421) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(195.4882074) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(32.2538571) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.4819467) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(40.6989059) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.5348517) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.7522591) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.5337643) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.7522591) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(191.5330296) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.7522591) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(195.5322949) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.7522591) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(138.0979215) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.4335956) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(138.0446638) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8039812) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.2912532) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.4335956) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.2912532) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8039812) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.4849376) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(8.4335956) + 'px', 
													top: _vm.gib_hoehe_in_mm(44.8568862) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(138.0446638) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.2433868) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.2912532) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.2433868) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(141.8467698) + 'px', 
													width: _vm.spalte_breit_mm(24.1010491) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(63.2985111) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(141.9000275) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(145.8989401) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(149.8982054) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(153.8974707) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(157.8963833) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(161.8956486) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(165.8945612) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.5483422) + 'px', 
													width: _vm.spalte_breit_mm(24.1006964) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(63.2985111) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.6012472) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(175.6005125) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(179.5997778) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.5986904) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.5979557) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(191.5968683) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(195.5961336) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(62.3515116) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(141.8679318) + 'px', 
													width: _vm.spalte_breit_mm(24.1006964) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(76.4059012) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(141.9208368) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(145.9201021) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(149.9190147) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(153.91828) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(157.9175453) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(161.9164579) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(165.9157232) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.5613921) + 'px', 
													width: _vm.spalte_breit_mm(24.1006964) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(76.4059012) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.6142971) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(175.6135624) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(179.6128277) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.6117403) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.6110056) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(191.6099182) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(195.6091835) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.4589017) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(138.0979215) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.5747711) + 'px', 
													top: _vm.gib_hoehe_in_mm(89.9911998) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(138.0446638) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(89.9379421) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.2912532) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(89.9379421) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.2912532) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.5747711) + 'px', 
													top: _vm.gib_hoehe_in_mm(89.9911998) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.4849376) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(7.5747711) + 'px', 
													top: _vm.gib_hoehe_in_mm(89.9911998) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(138.0446638) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(97.5188759) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.2912532) + 'px', 
													width: _vm.spalte_breit_mm(29.2465894) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(97.5188759) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.464597) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(104.464597) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.5175975) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.962999) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.962999) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.0159995) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(119.461401) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(119.461401) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(118.5144015) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.9594503) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.9594503) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.0128035) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4578523) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4578523) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(133.5112055) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.9562543) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.9562543) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(141.0096075) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(151.5362917) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(151.5362917) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(150.5892922) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7674492) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(168.1706818) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.8203542) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(152.8196195) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(156.8185321) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.8177974) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(177.9611336) + 'px', 
													width: _vm.spalte_breit_mm(12.1032532) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(168.1706818) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.0140386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(182.0133039) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(186.0122165) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0114818) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(167.2236823) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(159.4870603) + 'px', 
													width: _vm.spalte_breit_mm(36.0981396) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(197.6010279) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(159.5399653) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(163.5392306) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.5381432) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.5374085) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(175.5366738) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(179.5355864) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.5348517) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.5337643) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(191.5330296) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(195.5322949) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(196.6543811) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(123.5479884) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(131.5461663) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(135.5454316) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(139.5443442) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(143.5436095) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(147.5425221) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(151.5417874) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(155.5410527) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(159.5399653) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(163.5392306) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.5381432) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.5374085) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(175.5366738) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(179.5355864) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.5348517) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.5337643) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(191.5330296) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(195.5322949) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(127.546901) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(211.1510565) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(123.4950834) + 'px', 
													width: _vm.spalte_breit_mm(72.0901165) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(212.098056) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(203.8591892) + 'px', 
													width: _vm.spalte_breit_mm(5.7229102) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(0.084795499999984) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(209.5820994) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(5.577431) + 'px', 
													top: _vm.gib_hoehe_in_mm(0.084795499999984) + 'px'})})],1),_c('div',{staticStyle:{"font-family":"Arial, Verdana, sans-serif","border":"solid 1px black","position":"relative","width":"909px","height":"1286px","overflow":"hidden","background-color":"white","margin":"0 auto 10px"}},[_c('div',{style:({
														fontSize:'18px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.5972535) + 'px', 
														top: _vm.gib_hoehe_in_mm(22.0219537) + 'px'})},[_vm._v(" Statistik der Baufertigstellungen ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.5972535) + 'px', 
														top: _vm.gib_hoehe_in_mm(27.2101707) + 'px'})},[_vm._v(" Bitte lesen Sie vor dem Ausfüllen die dazugehörigen Erläuterungen. ")]),_c('div',{style:({
														fontSize:'33px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(90.978965) + 'px', 
														top: _vm.gib_hoehe_in_mm(21.8068067) + 'px'})},[_vm._v(" BF ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.8872413) + 'px', 
														top: _vm.gib_hoehe_in_mm(22.1076598) + 'px'})},[_vm._v(" Füllen Sie den Fragebogen aus bei ... ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.8872413) + 'px', 
														top: _vm.gib_hoehe_in_mm(25.9129401) + 'px'})},[_vm._v(" ... Neubau (für jedes Gebäude ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8862494) + 'px', 
														top: _vm.gib_hoehe_in_mm(29.4399401) + 'px'})},[_vm._v(" 1 Erhebungsbogen). ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.8872413) + 'px', 
														top: _vm.gib_hoehe_in_mm(32.9669401) + 'px'})},[_vm._v(" ... Baumaßnahmen an einem ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8862494) + 'px', 
														top: _vm.gib_hoehe_in_mm(36.4939401) + 'px'})},[_vm._v(" bestehenden Gebäude. ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(105.8872413) + 'px', 
														top: _vm.gib_hoehe_in_mm(40.0209401) + 'px'})},[_vm._v(" ... Änderung des Nutzungsschwer ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8862494) + 'px', 
														top: _vm.gib_hoehe_in_mm(42.9836201) + 'px'})},[_vm._v(" punkts zwischen Wohnbau und ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8862494) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.9463001) + 'px'})},[_vm._v(" Nichtwohnbau (bitte zusätzlich ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(108.8862494) + 'px', 
														top: _vm.gib_hoehe_in_mm(48.9089801) + 'px'})},[_vm._v(" einen Abgangsbogen ausfüllen). ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(21.407903) + 'px'})},[_vm._v(" Information und Technik ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(24.229503) + 'px'})},[_vm._v(" NorddrheinWestfalen ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(27.1399834) + 'px'})},[_vm._v(" Geschäftsbereich Statistik ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(30.3142834) + 'px'})},[_vm._v(" Referat 535 Paderborn ")]),_c('div',{style:({
														fontSize:'12.12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(33.5552437) + 'px'})},[_vm._v(" 40193 Düsseldorf ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(38.2514442) + 'px'})},[_vm._v(" Sie erreichen uns über ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(41.7202487) + 'px'})},[_vm._v(" Telefon 0211 9449 4664 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(45.1887005) + 'px'})},[_vm._v(" Telefax 0211 9449 4658 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(156.1378211) + 'px', 
														top: _vm.gib_hoehe_in_mm(48.657505) + 'px'})},[_vm._v(" EMail bautaetigkeitit.nrw.de ")]),_c('div',{style:({
														fontSize:'13.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.5972535) + 'px', 
														top: _vm.gib_hoehe_in_mm(53.0196986) + 'px'})},[_vm._v(" 1 Allgemeine Angaben 1 (Blockschrift) ")]),(_vm.formular.identnummer_Seite3)?_c('b-popover',{ref:"identnummer_Seite3",attrs:{"show":_vm.formular.identnummer_Seite3.showPop==true,"target":"identnummer_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.identnummer_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.identnummer_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("identnummer_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("identnummer_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.identnummer_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.identnummer_Seite3.text),expression:"formular.identnummer_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(39.2768006) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(7.395702) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(35.7187176) + 'px', 
		
														'font-size': _vm.formular.identnummer_Seite3.size + 'px', 
														'text-align': _vm.formular.identnummer_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.identnummer_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.identnummer_Seite3.schriftart }),attrs:{"id":"identnummer_Seite3","type":"text","disabled":_vm.formular.identnummer_Seite3.isDisabled==true || _vm.formular.identnummer_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.identnummer_Seite3.text)},on:{"focus":function($event){_vm.formular.identnummer_Seite3.showPop=true},"blur":function($event){_vm.formular.identnummer_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.identnummer_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.identnummer_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.bauscheinnummer_Seite3)?_c('b-popover',{ref:"bauscheinnummer_Seite3",attrs:{"show":_vm.formular.bauscheinnummer_Seite3.showPop==true,"target":"bauscheinnummer_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauscheinnummer_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauscheinnummer_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauscheinnummer_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauscheinnummer_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauscheinnummer_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauscheinnummer_Seite3.text),expression:"formular.bauscheinnummer_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(85.7312703) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(6.9001585) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(43.7049037) + 'px', 
		
														'font-size': _vm.formular.bauscheinnummer_Seite3.size + 'px', 
														'text-align': _vm.formular.bauscheinnummer_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauscheinnummer_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.bauscheinnummer_Seite3.schriftart }),attrs:{"id":"bauscheinnummer_Seite3","type":"text","disabled":_vm.formular.bauscheinnummer_Seite3.isDisabled==true || _vm.formular.bauscheinnummer_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.bauscheinnummer_Seite3.text)},on:{"focus":function($event){_vm.formular.bauscheinnummer_Seite3.showPop=true},"blur":function($event){_vm.formular.bauscheinnummer_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauscheinnummer_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauscheinnummer_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.5972535) + 'px', 
														top: _vm.gib_hoehe_in_mm(39.5268074) + 'px'})},[_vm._v(" Identifikationsnummer ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.5972535) + 'px', 
														top: _vm.gib_hoehe_in_mm(47.5658985) + 'px'})},[_vm._v(" Bauscheinnummer/Aktenzeichen ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5965188) + 'px', 
														top: _vm.gib_hoehe_in_mm(58.1437242) + 'px'})},[_vm._v(" Bauherr/Bauherrin ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5965188) + 'px', 
														top: _vm.gib_hoehe_in_mm(62.1983634) + 'px'})},[_vm._v(" Name/Firma ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5954607) + 'px', 
														top: _vm.gib_hoehe_in_mm(77.6392167) + 'px'})},[_vm._v(" Anschrift ")]),(_vm.formular.bauherr_name1_Seite3)?_c('b-popover',{ref:"bauherr_name1_Seite3",attrs:{"show":_vm.formular.bauherr_name1_Seite3.showPop==true,"target":"bauherr_name1_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_name1_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_name1_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name1_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name1_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_name1_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_name1_Seite3.text),expression:"formular.bauherr_name1_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1341047) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(32.9967842) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(65.7980317) + 'px', 
		
														'font-size': _vm.formular.bauherr_name1_Seite3.size + 'px', 
														'text-align': _vm.formular.bauherr_name1_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_name1_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_name1_Seite3.schriftart }),attrs:{"id":"bauherr_name1_Seite3","type":"text","disabled":_vm.formular.bauherr_name1_Seite3.isDisabled==true || _vm.formular.bauherr_name1_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_name1_Seite3.text)},on:{"focus":function($event){_vm.formular.bauherr_name1_Seite3.showPop=true},"blur":function($event){_vm.formular.bauherr_name1_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_name1_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_name1_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.bauherr_name2_Seite3)?_c('b-popover',{ref:"bauherr_name2_Seite3",attrs:{"show":_vm.formular.bauherr_name2_Seite3.showPop==true,"target":"bauherr_name2_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_name2_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_name2_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name2_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_name2_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_name2_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_name2_Seite3.text),expression:"formular.bauherr_name2_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1341047) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(32.9967842) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(72.2968819) + 'px', 
		
														'font-size': _vm.formular.bauherr_name2_Seite3.size + 'px', 
														'text-align': _vm.formular.bauherr_name2_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_name2_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_name2_Seite3.schriftart }),attrs:{"id":"bauherr_name2_Seite3","type":"text","disabled":_vm.formular.bauherr_name2_Seite3.isDisabled==true || _vm.formular.bauherr_name2_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_name2_Seite3.text)},on:{"focus":function($event){_vm.formular.bauherr_name2_Seite3.showPop=true},"blur":function($event){_vm.formular.bauherr_name2_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_name2_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_name2_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.bauherr_anschrift1_Seite3)?_c('b-popover',{ref:"bauherr_anschrift1_Seite3",attrs:{"show":_vm.formular.bauherr_anschrift1_Seite3.showPop==true,"target":"bauherr_anschrift1_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_anschrift1_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_anschrift1_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift1_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift1_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_anschrift1_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_anschrift1_Seite3.text),expression:"formular.bauherr_anschrift1_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1341047) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(32.9967842) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(78.7953794) + 'px', 
		
														'font-size': _vm.formular.bauherr_anschrift1_Seite3.size + 'px', 
														'text-align': _vm.formular.bauherr_anschrift1_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_anschrift1_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_anschrift1_Seite3.schriftart }),attrs:{"id":"bauherr_anschrift1_Seite3","type":"text","disabled":_vm.formular.bauherr_anschrift1_Seite3.isDisabled==true || _vm.formular.bauherr_anschrift1_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_anschrift1_Seite3.text)},on:{"focus":function($event){_vm.formular.bauherr_anschrift1_Seite3.showPop=true},"blur":function($event){_vm.formular.bauherr_anschrift1_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_anschrift1_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_anschrift1_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.bauherr_anschrift2_Seite3)?_c('b-popover',{ref:"bauherr_anschrift2_Seite3",attrs:{"show":_vm.formular.bauherr_anschrift2_Seite3.showPop==true,"target":"bauherr_anschrift2_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.bauherr_anschrift2_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.bauherr_anschrift2_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift2_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("bauherr_anschrift2_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.bauherr_anschrift2_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.bauherr_anschrift2_Seite3.text),expression:"formular.bauherr_anschrift2_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(67.1341047) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(32.9967842) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(85.788715) + 'px', 
		
														'font-size': _vm.formular.bauherr_anschrift2_Seite3.size + 'px', 
														'text-align': _vm.formular.bauherr_anschrift2_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.bauherr_anschrift2_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.bauherr_anschrift2_Seite3.schriftart }),attrs:{"id":"bauherr_anschrift2_Seite3","type":"text","disabled":_vm.formular.bauherr_anschrift2_Seite3.isDisabled==true || _vm.formular.bauherr_anschrift2_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.bauherr_anschrift2_Seite3.text)},on:{"focus":function($event){_vm.formular.bauherr_anschrift2_Seite3.showPop=true},"blur":function($event){_vm.formular.bauherr_anschrift2_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.bauherr_anschrift2_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.bauherr_anschrift2_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5965188) + 'px', 
														top: _vm.gib_hoehe_in_mm(92.6910419) + 'px'})},[_vm._v(" Anschrift des Baugrundstücks ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5954607) + 'px', 
														top: _vm.gib_hoehe_in_mm(96.744623) + 'px'})},[_vm._v(" Straße, ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5965188) + 'px', 
														top: _vm.gib_hoehe_in_mm(100.271623) + 'px'})},[_vm._v(" Nummer ")]),(_vm.formular.baugrundstueck_strasse_Seite3)?_c('b-popover',{ref:"baugrundstueck_strasse_Seite3",attrs:{"show":_vm.formular.baugrundstueck_strasse_Seite3.showPop==true,"target":"baugrundstueck_strasse_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_strasse_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_strasse_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_strasse_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_strasse_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_strasse_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_strasse_Seite3.text),expression:"formular.baugrundstueck_strasse_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(52.683633) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(32.9967842) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(99.427624) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_strasse_Seite3.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_strasse_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_strasse_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_strasse_Seite3.schriftart }),attrs:{"id":"baugrundstueck_strasse_Seite3","type":"text","disabled":_vm.formular.baugrundstueck_strasse_Seite3.isDisabled==true || _vm.formular.baugrundstueck_strasse_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_strasse_Seite3.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_strasse_Seite3.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_strasse_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_strasse_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_strasse_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5954607) + 'px', 
														top: _vm.gib_hoehe_in_mm(104.8253327) + 'px'})},[_vm._v(" Postleitzahl, ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5965188) + 'px', 
														top: _vm.gib_hoehe_in_mm(108.3523327) + 'px'})},[_vm._v(" Ort ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5954607) + 'px', 
														top: _vm.gib_hoehe_in_mm(116.4051791) + 'px'})},[_vm._v(" Lage des Baugrundstücks ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5954607) + 'px', 
														top: _vm.gib_hoehe_in_mm(123.9035811) + 'px'})},[_vm._v(" Gemeinde ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5954607) + 'px', 
														top: _vm.gib_hoehe_in_mm(132.4018876) + 'px'})},[_vm._v(" Gemeindeteil ")]),(_vm.formular.baugrundstueck_gemeinde_Seite3)?_c('b-popover',{ref:"baugrundstueck_gemeinde_Seite3",attrs:{"show":_vm.formular.baugrundstueck_gemeinde_Seite3.showPop==true,"target":"baugrundstueck_gemeinde_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_gemeinde_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_gemeinde_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeinde_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeinde_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_gemeinde_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_gemeinde_Seite3.text),expression:"formular.baugrundstueck_gemeinde_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.004399) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.4015221) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(123.5015152) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_gemeinde_Seite3.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_gemeinde_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_gemeinde_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_gemeinde_Seite3.schriftart }),attrs:{"id":"baugrundstueck_gemeinde_Seite3","type":"text","disabled":_vm.formular.baugrundstueck_gemeinde_Seite3.isDisabled==true || _vm.formular.baugrundstueck_gemeinde_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_gemeinde_Seite3.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_gemeinde_Seite3.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_gemeinde_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_gemeinde_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_gemeinde_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.baugrundstueck_gemeindeTeil_Seite3)?_c('b-popover',{ref:"baugrundstueck_gemeindeTeil_Seite3",attrs:{"show":_vm.formular.baugrundstueck_gemeindeTeil_Seite3.showPop==true,"target":"baugrundstueck_gemeindeTeil_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_gemeindeTeil_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_gemeindeTeil_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeindeTeil_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_gemeindeTeil_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_gemeindeTeil_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_gemeindeTeil_Seite3.text),expression:"formular.baugrundstueck_gemeindeTeil_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.004399) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.4015221) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(131.999469) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_gemeindeTeil_Seite3.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_gemeindeTeil_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_gemeindeTeil_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_gemeindeTeil_Seite3.schriftart }),attrs:{"id":"baugrundstueck_gemeindeTeil_Seite3","type":"text","disabled":_vm.formular.baugrundstueck_gemeindeTeil_Seite3.isDisabled==true || _vm.formular.baugrundstueck_gemeindeTeil_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_gemeindeTeil_Seite3.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_gemeindeTeil_Seite3.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_gemeindeTeil_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_gemeindeTeil_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_gemeindeTeil_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5968715) + 'px', 
														top: _vm.gib_hoehe_in_mm(138.4552777) + 'px'})},[_vm._v(" Datum der Baugenehmigung ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5968715) + 'px', 
														top: _vm.gib_hoehe_in_mm(141.9822777) + 'px'})},[_vm._v(" bzw. Genehmigungsfreistellung ..................... ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5968715) + 'px', 
														top: _vm.gib_hoehe_in_mm(147.0766765) + 'px'})},[_vm._v(" Datum der ")]),_c('div',{style:({
														fontSize:'10.5px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5968715) + 'px', 
														top: _vm.gib_hoehe_in_mm(150.6036765) + 'px'})},[_vm._v(" Bezugsfertigstellung ......................................... ")]),(_vm.formular.BG_Monat_Seite3)?_c('b-popover',{ref:"BG_Monat_Seite3",attrs:{"show":_vm.formular.BG_Monat_Seite3.showPop==true,"target":"BG_Monat_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.BG_Monat_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.BG_Monat_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Monat_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Monat_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.BG_Monat_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.BG_Monat_Seite3.text),expression:"formular.BG_Monat_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(8.4980824) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(75.1857001) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(141.3174503) + 'px', 
		
														'font-size': _vm.formular.BG_Monat_Seite3.size + 'px', 
														'text-align': _vm.formular.BG_Monat_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.BG_Monat_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.BG_Monat_Seite3.schriftart }),attrs:{"id":"BG_Monat_Seite3","type":"text","disabled":_vm.formular.BG_Monat_Seite3.isDisabled==true || _vm.formular.BG_Monat_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.BG_Monat_Seite3.text)},on:{"focus":function($event){_vm.formular.BG_Monat_Seite3.showPop=true},"blur":function($event){_vm.formular.BG_Monat_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.BG_Monat_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.BG_Monat_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.BG_Jahr_Seite3)?_c('b-popover',{ref:"BG_Jahr_Seite3",attrs:{"show":_vm.formular.BG_Jahr_Seite3.showPop==true,"target":"BG_Jahr_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.BG_Jahr_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.BG_Jahr_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Jahr_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BG_Jahr_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.BG_Jahr_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.BG_Jahr_Seite3.text),expression:"formular.BG_Jahr_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(16.4959076) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(86.2894015) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(141.3174503) + 'px', 
		
														'font-size': _vm.formular.BG_Jahr_Seite3.size + 'px', 
														'text-align': _vm.formular.BG_Jahr_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.BG_Jahr_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.BG_Jahr_Seite3.schriftart }),attrs:{"id":"BG_Jahr_Seite3","type":"text","disabled":_vm.formular.BG_Jahr_Seite3.isDisabled==true || _vm.formular.BG_Jahr_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.BG_Jahr_Seite3.text)},on:{"focus":function($event){_vm.formular.BG_Jahr_Seite3.showPop=true},"blur":function($event){_vm.formular.BG_Jahr_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.BG_Jahr_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.BG_Jahr_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(75.9800448) + 'px', 
														top: _vm.gib_hoehe_in_mm(144.5792078) + 'px'})},[_vm._v(" Monat ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(91.6716678) + 'px', 
														top: _vm.gib_hoehe_in_mm(144.5792078) + 'px'})},[_vm._v(" Jahr ")]),(_vm.formular.BZ_Monat_Seite3)?_c('b-popover',{ref:"BZ_Monat_Seite3",attrs:{"show":_vm.formular.BZ_Monat_Seite3.showPop==true,"target":"BZ_Monat_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.BZ_Monat_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.BZ_Monat_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BZ_Monat_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BZ_Monat_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.BZ_Monat_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.BZ_Monat_Seite3.text),expression:"formular.BZ_Monat_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(8.4980824) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(75.1857001) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(149.9384964) + 'px', 
		
														'font-size': _vm.formular.BZ_Monat_Seite3.size + 'px', 
														'text-align': _vm.formular.BZ_Monat_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.BZ_Monat_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.BZ_Monat_Seite3.schriftart }),attrs:{"id":"BZ_Monat_Seite3","type":"text","disabled":_vm.formular.BZ_Monat_Seite3.isDisabled==true || _vm.formular.BZ_Monat_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.BZ_Monat_Seite3.text)},on:{"focus":function($event){_vm.formular.BZ_Monat_Seite3.showPop=true},"blur":function($event){_vm.formular.BZ_Monat_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.BZ_Monat_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.BZ_Monat_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.BZ_Jahr_Seite3)?_c('b-popover',{ref:"BZ_Jahr_Seite3",attrs:{"show":_vm.formular.BZ_Jahr_Seite3.showPop==true,"target":"BZ_Jahr_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.BZ_Jahr_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.BZ_Jahr_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BZ_Jahr_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("BZ_Jahr_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.BZ_Jahr_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.BZ_Jahr_Seite3.text),expression:"formular.BZ_Jahr_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(16.4959076) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(86.2894015) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(149.9384964) + 'px', 
		
														'font-size': _vm.formular.BZ_Jahr_Seite3.size + 'px', 
														'text-align': _vm.formular.BZ_Jahr_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.BZ_Jahr_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.BZ_Jahr_Seite3.schriftart }),attrs:{"id":"BZ_Jahr_Seite3","type":"text","disabled":_vm.formular.BZ_Jahr_Seite3.isDisabled==true || _vm.formular.BZ_Jahr_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.BZ_Jahr_Seite3.text)},on:{"focus":function($event){_vm.formular.BZ_Jahr_Seite3.showPop=true},"blur":function($event){_vm.formular.BZ_Jahr_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.BZ_Jahr_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.BZ_Jahr_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(75.9800448) + 'px', 
														top: _vm.gib_hoehe_in_mm(153.2006066) + 'px'})},[_vm._v(" Monat ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(91.6716678) + 'px', 
														top: _vm.gib_hoehe_in_mm(153.2006066) + 'px'})},[_vm._v(" Jahr ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5968715) + 'px', 
														top: _vm.gib_hoehe_in_mm(155.6980753) + 'px'})},[_vm._v(" Haben sich seit Einreichung des ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'bold',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5968715) + 'px', 
														top: _vm.gib_hoehe_in_mm(159.0839953) + 'px'})},[_vm._v(" Erhebungsbogens für Baugenehmigung ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(10.5968715) + 'px', 
														top: _vm.gib_hoehe_in_mm(162.6109953) + 'px'})},[_vm._v(" Änderungen ergeben ? ....................................................... 1 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(89.7568595) + 'px', 
														top: _vm.gib_hoehe_in_mm(157.6259335) + 'px'})},[_vm._v(" Ja ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(96.255357) + 'px', 
														top: _vm.gib_hoehe_in_mm(157.6259335) + 'px'})},[_vm._v(" Nein ")]),(_vm.formular.aenderungseiteEinreichenja!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(89.8094118) + 'px',top: _vm.gib_hoehe_in_mm(162.191006) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.aenderungseiteEinreichenja.text),callback:function ($$v) {_vm.$set(_vm.formular.aenderungseiteEinreichenja, "text", $$v)},expression:"formular.aenderungseiteEinreichenja.text"}}):_vm._e(),(_vm.formular.aenderungseiteEinreichennein!=undefined)?_c('b-form-checkbox',{staticClass:"size_10 input_formular",staticStyle:{"min-height":"1rem !important"},style:({position:'absolute', 
														fontSize:'14px',
														fontWeight:'bold',
														paddingBottom :'5px',
														left: _vm.spalte_breit_mm(98.7235516) + 'px',top: _vm.gib_hoehe_in_mm(162.191006) + 'px'}),attrs:{"size":"sm","disabled":false,"value":"1","unchecked-value":"0"},model:{value:(_vm.formular.aenderungseiteEinreichennein.text),callback:function ($$v) {_vm.$set(_vm.formular.aenderungseiteEinreichennein, "text", $$v)},expression:"formular.aenderungseiteEinreichennein.text"}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(96.4941349) + 'px', 
														top: _vm.gib_hoehe_in_mm(163.1675559) + 'px'})},[_vm._v(" 2 ")]),_c('div',{style:({
														fontSize:'12px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5869981) + 'px', 
														top: _vm.gib_hoehe_in_mm(88.7725449) + 'px'})},[_vm._v(" Ansprechpartner/in für Rückfragen ")]),(_vm.formular.baugrundstueck_nummer_Seite3)?_c('b-popover',{ref:"baugrundstueck_nummer_Seite3",attrs:{"show":_vm.formular.baugrundstueck_nummer_Seite3.showPop==true,"target":"baugrundstueck_nummer_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_nummer_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_nummer_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_nummer_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_nummer_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_nummer_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_nummer_Seite3.text),expression:"formular.baugrundstueck_nummer_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(10.4421648) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(90.5736484) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(99.427624) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_nummer_Seite3.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_nummer_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_nummer_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_nummer_Seite3.schriftart }),attrs:{"id":"baugrundstueck_nummer_Seite3","type":"text","disabled":_vm.formular.baugrundstueck_nummer_Seite3.isDisabled==true || _vm.formular.baugrundstueck_nummer_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_nummer_Seite3.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_nummer_Seite3.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_nummer_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_nummer_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_nummer_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.ansprechpartnerName_Seite3)?_c('b-popover',{ref:"ansprechpartnerName_Seite3",attrs:{"show":_vm.formular.ansprechpartnerName_Seite3.showPop==true,"target":"ansprechpartnerName_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.ansprechpartnerName_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.ansprechpartnerName_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerName_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerName_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.ansprechpartnerName_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.ansprechpartnerName_Seite3.text),expression:"formular.ansprechpartnerName_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(87.7497724) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(107.4485799) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(96.6462318) + 'px', 
		
														'font-size': _vm.formular.ansprechpartnerName_Seite3.size + 'px', 
														'text-align': _vm.formular.ansprechpartnerName_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.ansprechpartnerName_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.ansprechpartnerName_Seite3.schriftart }),attrs:{"id":"ansprechpartnerName_Seite3","type":"text","disabled":_vm.formular.ansprechpartnerName_Seite3.isDisabled==true || _vm.formular.ansprechpartnerName_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.ansprechpartnerName_Seite3.text)},on:{"focus":function($event){_vm.formular.ansprechpartnerName_Seite3.showPop=true},"blur":function($event){_vm.formular.ansprechpartnerName_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.ansprechpartnerName_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.ansprechpartnerName_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5337404) + 'px', 
														top: _vm.gib_hoehe_in_mm(100.1749832) + 'px'})},[_vm._v(" Name (z. B. Architekt/in, Planverfasser/in) ")]),(_vm.formular.baugrundstueck_plz_Seite3)?_c('b-popover',{ref:"baugrundstueck_plz_Seite3",attrs:{"show":_vm.formular.baugrundstueck_plz_Seite3.showPop==true,"target":"baugrundstueck_plz_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_plz_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_plz_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_plz_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_plz_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_plz_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_plz_Seite3.text),expression:"formular.baugrundstueck_plz_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(10.4421648) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(31.7870232) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(107.5090391) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_plz_Seite3.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_plz_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_plz_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_plz_Seite3.schriftart }),attrs:{"id":"baugrundstueck_plz_Seite3","type":"text","disabled":_vm.formular.baugrundstueck_plz_Seite3.isDisabled==true || _vm.formular.baugrundstueck_plz_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_plz_Seite3.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_plz_Seite3.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_plz_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_plz_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_plz_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.baugrundstueck_ort_Seite3)?_c('b-popover',{ref:"baugrundstueck_ort_Seite3",attrs:{"show":_vm.formular.baugrundstueck_ort_Seite3.showPop==true,"target":"baugrundstueck_ort_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.baugrundstueck_ort_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.baugrundstueck_ort_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_ort_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("baugrundstueck_ort_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.baugrundstueck_ort_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.baugrundstueck_ort_Seite3.text),expression:"formular.baugrundstueck_ort_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(55.3073683) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(45.7084449) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(107.5090391) + 'px', 
		
														'font-size': _vm.formular.baugrundstueck_ort_Seite3.size + 'px', 
														'text-align': _vm.formular.baugrundstueck_ort_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.baugrundstueck_ort_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.baugrundstueck_ort_Seite3.schriftart }),attrs:{"id":"baugrundstueck_ort_Seite3","type":"text","disabled":_vm.formular.baugrundstueck_ort_Seite3.isDisabled==true || _vm.formular.baugrundstueck_ort_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.baugrundstueck_ort_Seite3.text)},on:{"focus":function($event){_vm.formular.baugrundstueck_ort_Seite3.showPop=true},"blur":function($event){_vm.formular.baugrundstueck_ort_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.baugrundstueck_ort_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.baugrundstueck_ort_Seite3, "text", $event.target.value)}}}):_vm._e(),(_vm.formular.ansprechpartnerTelefon_Seite3)?_c('b-popover',{ref:"ansprechpartnerTelefon_Seite3",attrs:{"show":_vm.formular.ansprechpartnerTelefon_Seite3.showPop==true,"target":"ansprechpartnerTelefon_Seite3"}},[_c('template',{slot:"title"},[_c('b-button',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function($event){_vm.formular.ansprechpartnerTelefon_Seite3.showPop=false;}}},[_c('span',{staticClass:"d-inline-block",attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" Schriftgröße ")],1),_c('span',{staticStyle:{"font-size":"1.0em","font-weight":"700","margin-right":"10px"}},[_vm._v(_vm._s(_vm.formular.ansprechpartnerTelefon_Seite3.size))]),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerTelefon_Seite3", "+")}}},[_vm._v("+")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.plus("ansprechpartnerTelefon_Seite3", "-")}}},[_vm._v("-")])],2):_vm._e(),(_vm.formular.ansprechpartnerTelefon_Seite3!=undefined)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formular.ansprechpartnerTelefon_Seite3.text),expression:"formular.ansprechpartnerTelefon_Seite3.text"}],staticClass:"textfeld",staticStyle:{"width":"100%"},style:({'width': _vm.spalte_breit_mm(87.7497724) + 'px', 
														'position':'absolute', 
														'left': _vm.spalte_breit_mm(107.4485799) + 'px', 
														'height': 16.5 + 'px', 
														'top': _vm.gib_hoehe_in_mm(107.352793) + 'px', 
		
														'font-size': _vm.formular.ansprechpartnerTelefon_Seite3.size + 'px', 
														'text-align': _vm.formular.ansprechpartnerTelefon_Seite3.schriftausrichtung, 
														'letter-spacing': _vm.formular.ansprechpartnerTelefon_Seite3.letterSpacing + 'px',
														'font-weight': _vm.formular.ansprechpartnerTelefon_Seite3.schriftart }),attrs:{"id":"ansprechpartnerTelefon_Seite3","type":"text","disabled":_vm.formular.ansprechpartnerTelefon_Seite3.isDisabled==true || _vm.formular.ansprechpartnerTelefon_Seite3.isDisabled==true},domProps:{"value":(_vm.formular.ansprechpartnerTelefon_Seite3.text)},on:{"focus":function($event){_vm.formular.ansprechpartnerTelefon_Seite3.showPop=true},"blur":function($event){_vm.formular.ansprechpartnerTelefon_Seite3.showPop=false},"keypress":function($event){return _vm.isNumber($event, _vm.formular.ansprechpartnerTelefon_Seite3.onylNumber)},"input":function($event){if($event.target.composing)return;_vm.$set(_vm.formular.ansprechpartnerTelefon_Seite3, "text", $event.target.value)}}}):_vm._e(),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(106.5869981) + 'px', 
														top: _vm.gib_hoehe_in_mm(111.3933121) + 'px'})},[_vm._v(" Telefon und/oder EMail ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(6.5972535) + 'px', 
														top: _vm.gib_hoehe_in_mm(279.5536181) + 'px'})},[_vm._v(" BF ")]),_c('div',{style:({
														fontSize:'9px',
														fontWeight:'normal',
														
														 position:'absolute', 
														left: _vm.spalte_breit_mm(195.8042266) + 'px', 
														top: _vm.gib_hoehe_in_mm(279.5536181) + 'px'})},[_vm._v(" Seite 1 ")]),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.5972535) + 'px', 
													width: _vm.spalte_breit_mm(40.8969758) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(39.4030861) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.6505112) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.4564393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.6505112) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.4564393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(47.4392081) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(38.4564393) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.6501585) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.1735067) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(19.4351808) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(23.6965022) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(27.9581763) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.2198504) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(36.4811718) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(40.7428459) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(45.00452) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(49.2658414) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(53.5275155) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(57.7891896) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(62.0508637) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(66.3125378) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(70.5738592) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.8355333) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(79.0972074) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(83.3585288) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.6202029) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(91.881877) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(10.9118326) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(46.4955304) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.5972535) + 'px', 
													width: _vm.spalte_breit_mm(85.3375285) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(47.4425299) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.0967581) + 'px', 
													width: _vm.spalte_breit_mm(68.9849457) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(76.1138656) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1496631) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.1668661) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0139854) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(75.1668661) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.0967581) + 'px', 
													width: _vm.spalte_breit_mm(68.9849457) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(69.6150154) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1496631) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.6683686) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0139854) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(68.6683686) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.0967581) + 'px', 
													width: _vm.spalte_breit_mm(68.9849457) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(89.1108606) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1496631) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1002572) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.1638611) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0139854) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1002572) + 'px', 
													top: _vm.gib_hoehe_in_mm(88.1638611) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.0967581) + 'px', 
													width: _vm.spalte_breit_mm(68.9849457) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(82.6123631) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(32.1496631) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(81.6653636) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.0139854) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(81.6653636) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.1091981) + 'px', 
													width: _vm.spalte_breit_mm(56.9765688) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.2449604) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.1515221) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.2979609) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(88.0289822) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.2979609) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.9293298) + 'px', 
													width: _vm.spalte_breit_mm(11.9135006) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(103.2449604) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.9385) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.2979609) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.8308386) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.2979609) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.9068221) + 'px', 
													width: _vm.spalte_breit_mm(56.9769215) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.3260228) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(44.9494988) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3783179) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(101.8266062) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3783179) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.1427046) + 'px', 
													width: _vm.spalte_breit_mm(11.9131479) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.3260228) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.1518748) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3783179) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(43.0442134) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1006099) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3783179) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.0986171) + 'px', 
													width: _vm.spalte_breit_mm(56.6771265) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(126.8765658) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.1515221) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(125.929919) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.7295399) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(125.929919) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.0986171) + 'px', 
													width: _vm.spalte_breit_mm(56.6771265) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(135.3748723) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.1515221) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4278728) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(87.7295399) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(134.4278728) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.8827951) + 'px', 
													width: _vm.spalte_breit_mm(8.1043406) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.9556151) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.9357001) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(78.9349654) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.933878) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0995518) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(86.0394015) + 'px', 
													width: _vm.spalte_breit_mm(15.9963558) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.9556151) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(86.0394015) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.0383141) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(94.0375794) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.036492) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.0357573) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0466468) + 'px', 
													top: _vm.gib_hoehe_in_mm(144.0089683) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.8827951) + 'px', 
													width: _vm.spalte_breit_mm(8.1043406) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(153.5766612) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(74.9357001) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(78.9349654) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.933878) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(85.9861438) + 'px', 
													width: _vm.spalte_breit_mm(16.1025185) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(153.5766612) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(86.0394015) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(90.0383141) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(94.0375794) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.036492) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.0357573) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(152.6300144) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.8094118) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(165.58398) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.2027385) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(162.191006) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.8094118) + 'px', 
													width: _vm.spalte_breit_mm(3.3933267) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(162.191006) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(89.8094118) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(162.191006) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.7235516) + 'px', 
													width: _vm.spalte_breit_mm(3.392974) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(165.58398) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.1165256) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(162.191006) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.7235516) + 'px', 
													width: _vm.spalte_breit_mm(3.392974) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(162.191006) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.7235516) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(3.492974) + 'px', 
													top: _vm.gib_hoehe_in_mm(162.191006) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1290318) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(30.1235875) + 'px', 
													top: _vm.gib_hoehe_in_mm(23.0801301) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(154.9911934) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(30.1235875) + 'px', 
													top: _vm.gib_hoehe_in_mm(23.0801301) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1290318) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(10.0859951) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.2095276) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.0761268) + 'px', 
													width: _vm.spalte_breit_mm(1.111005) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.1569753) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(105.1871318) + 'px', 
													width: _vm.spalte_breit_mm(1.3995136) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.1569753) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.5866454) + 'px', 
													width: _vm.spalte_breit_mm(48.404548) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.1569753) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(154.9911934) + 'px', 
													width: _vm.spalte_breit_mm(29.5784801) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.1569753) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(184.5696735) + 'px', 
													width: _vm.spalte_breit_mm(17.8610807) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(53.1569753) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1290318) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(9.0980824) + 'px', 
													top: _vm.gib_hoehe_in_mm(63.1955227) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1290318) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(10.1523027) + 'px', 
													top: _vm.gib_hoehe_in_mm(72.1939578) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1290318) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(9.6525268) + 'px', 
													top: _vm.gib_hoehe_in_mm(82.2462605) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1290318) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(10.9250684) + 'px', 
													top: _vm.gib_hoehe_in_mm(91.7987873) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.1290318) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(11.3387855) + 'px', 
													top: _vm.gib_hoehe_in_mm(102.6238557) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.5866454) + 'px', 
													width: _vm.spalte_breit_mm(90.0862813) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(111.2688854) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.6395504) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3222386) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.6179055) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(110.3211805) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.5972535) + 'px', 
													width: _vm.spalte_breit_mm(1.0499879) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(8.447165) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(10.7464163) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(13.0460203) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.3456243) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(17.6448756) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(19.9444796) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(22.2440836) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(24.5436876) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(26.8429389) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(29.1425429) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.4421469) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(33.7413982) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(36.0410022) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(38.3406062) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(40.6398575) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(42.9394615) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(45.2390655) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(47.5383168) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(49.8379208) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(52.1375248) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.4371288) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(56.7363801) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(59.0359841) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(61.3355881) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(63.6348394) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(65.9344434) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(68.2340474) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(70.5332987) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(72.8329027) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(75.1325067) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(77.4321107) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(79.731362) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(82.030966) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(84.33057) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(86.6298213) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(88.9294253) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(91.2290293) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.5282806) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(95.8278846) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.1274886) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(100.4270926) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.7263439) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(105.0259479) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(107.3255519) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(109.6251559) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(111.9244072) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(114.2240112) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(116.5236152) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(118.8228665) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(121.1224705) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(123.4220745) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(125.7213258) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(128.0209298) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(130.3205338) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(132.6197851) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(134.9193891) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(137.2189931) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(139.5185971) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(141.8178484) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(144.1174524) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(146.4170564) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.7163077) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(151.0159117) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(153.3155157) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(155.614767) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(157.914371) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.213975) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(162.513579) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(164.8128303) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.1124343) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(169.4120383) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.7112896) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(174.0108936) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(176.3104976) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.6097489) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(180.9093529) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.2089569) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(185.5082082) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.8078122) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.1074162) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(192.4070202) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(194.7062715) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(197.0058755) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(199.3054795) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(201.6047308) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(203.9043348) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(206.2039388) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(208.5031901) + 'px', 
													width: _vm.spalte_breit_mm(1.0499879) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(0.5808969) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(1.4986223) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(3.7982263) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(6.0974776) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(8.3970816) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(10.6966856) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(12.9959369) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(15.2955409) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(17.5951449) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(19.8943962) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(22.1940002) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(24.4936042) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(26.7932082) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(29.0924595) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(31.3920635) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(33.6916675) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(35.9909188) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(38.2905228) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(40.5901268) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(42.8893781) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(45.1889821) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(47.4885861) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(49.7878374) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(52.0874414) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(54.3870454) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(56.6866494) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(58.9859007) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(61.2855047) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(63.5851087) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(65.88436) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(68.183964) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(70.483568) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(72.7828193) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(75.0824233) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(77.3820273) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(79.6812786) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(81.9808826) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(84.2804866) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(86.5800906) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(88.8793419) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(91.1789459) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(93.4785499) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(95.7778012) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(98.0774052) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(100.3770092) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(102.6766132) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(104.9758645) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(107.2754685) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(109.5750725) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(111.8746765) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(114.1739278) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(116.4735318) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(118.7731358) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(121.0723871) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(123.3719911) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(125.6715951) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(127.9708464) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(130.2704504) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(132.5700544) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(134.8693057) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(137.1689097) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(139.4685137) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(141.7681177) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(144.067369) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(146.366973) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(148.666577) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(150.9658283) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(153.2654323) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(155.5650363) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(157.8642876) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(160.1638916) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(162.4634956) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(164.7627469) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(167.0623509) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(169.3619549) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(171.6615589) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(173.9608102) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(176.2604142) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(178.5600182) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(180.8592695) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(183.1588735) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(185.4584775) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(187.7577288) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(190.0573328) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(192.3569368) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(194.6565408) + 'px', 
													width: _vm.spalte_breit_mm(1.4993277) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.9557921) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(199.2553961) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(201.5550001) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(203.8542514) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(206.1538554) + 'px', 
													width: _vm.spalte_breit_mm(1.4996804) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(208.4534594) + 'px', 
													width: _vm.spalte_breit_mm(1.0997186) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(115.6039211) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.5337404) + 'px', 
													width: _vm.spalte_breit_mm(90.0862813) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(100.5104773) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(106.5866454) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.1002572) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5631251) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(196.5650005) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(1.0999045) + 'px', 
													top: _vm.gib_hoehe_in_mm(99.5613616) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(0.1178018) + 'px', 
													width: _vm.spalte_breit_mm(209.4353762) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(20.5805452) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(203.6443949) + 'px', 
													width: _vm.spalte_breit_mm(5.9087831) + 'px', 
													height:_vm.gib_hoehe_in_mm(0.1) + 'px', 
													top: _vm.gib_hoehe_in_mm(0.084795499999984) + 'px'})}),_c('div',{style:({	border: 'solid 1px grey',
													position:'absolute',
													left: _vm.spalte_breit_mm(209.553178) + 'px', 
													width: _vm.spalte_breit_mm(0) + 'px', 
													height:_vm.gib_hoehe_in_mm(4.8840228) + 'px', 
													top: _vm.gib_hoehe_in_mm(0.084795499999984) + 'px'})})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }